// Telugu translations for the business management application
export default {
  // Landing page translations
  landing: {
    hero: {
      badge: 'భారతీయ SMEల కోసం',
      title: 'మీ వ్యాపారాన్ని నడపండి.',
      subtitle: 'కాగితపు పని కాదు.',
      description: 'భారతీయ SMEల కోసం రాబోయే ఎంటర్‌ప్రైజ్ OS. స్థానిక-మొదటి లగ్జరీతో GST, ఇన్వెంటరీ మరియు వాణిజ్య ఫైనాన్స్‌ను సులభతరం చేయండి.',
      cta_waitlist: 'వెయిట్‌లిస్ట్‌లో చేరండి',
      cta_demo: 'ఆర్కిటెక్చర్ చూడండి',
      trust_early: 'త్వరలో ఎర్లీ యాక్సెస్',
      trust_card: 'క్రెడిట్ కార్డ్ అవసరం లేదు',
      trust_gst: 'GST పై దృష్టి',
      stats_revenue: 'ఆదాయం',
      stats_inventory: 'ఇన్వెంటరీ'
    },
    social_proof: {
      stats: {
        smes: { value: 'భారతీయ SMEలు', label: 'కోసం నిర్మిస్తున్నారు' },
        gst: { value: 'GST పై దృష్టి', label: 'అనుకూలత' },
        cloud: { value: 'క్లౌడ్ నేటివ్', label: 'ఆర్కిటెక్చర్' },
        status: { value: 'ఎర్లీ యాక్సెస్', label: 'స్థితి' }
      }
    },
    problem: {
      badge: 'క్లిష్టమైన సవాళ్లు',
      title: 'మీ స్కేల్‌ను వెనుకకు లాగుతున్న',
      subtitle: 'రాపిడి.',
      description: "ఆధునిక భారతీయ వ్యాపార దృశ్యం వేగంగా అభివృద్ధి చెందుతోంది. లెగసీ టూల్స్ డిజిటల్ వాణిజ్యం మరియు GST సంక్లిష్టత యొక్క వేగం కోసం నిర్మించబడలేదు.",
      cards: {
        paperwork: {
          title: 'కాగితపు పనిలో కోల్పోయిన గంటలు',
          description: 'మాన్యువల్ ఇన్వాయిసింగ్, డేటా ఎంట్రీ మరియు సయోధ్య ప్రతి వారం 15+ గంటలను తింటాయి. మీరు వృద్ధిపై గడపవలసిన సమయం.'
        },
        gst: {
          title: 'GST అనుకూలత తలనొప్పులు',
          description: 'సరైన పన్ను రేట్లను లెక్కించడం, సమయానికి రిటర్న్స్ దాఖలు చేయడం మరియు పెనాల్టీలను నివారించడం నిరంతర సాంకేతిక మరియు మానసిక ఒత్తిడి.'
        },
        inventory: {
          title: 'ఇన్వెంటరీ బ్లైండ్ స్పాట్స్',
          description: "స్టాక్‌అవుట్‌లు మరియు ఓవర్‌స్టాకింగ్ జరుగుతాయి ఎందుకంటే మీ మొత్తం గిడ్డంగి నెట్‌వర్క్‌లో మీకు నిజ-సమయ దృశ్యమానత లేదు."
        }
      }
    },
    features: {
      title: 'ఎంటర్‌ప్రైజ్ పవర్.',
      subtitle: 'మీ కోసం సరళీకృతం.',
      description: 'సోమా పారిశ్రామిక-స్థాయి అకౌంటింగ్‌ను ఆధునిక వ్యాపార యజమాని కోసం రూపొందించిన అతుకులు లేని ఇంటర్‌ఫేస్‌తో మిళితం చేస్తుంది.',
      cards: {
        invoicing: {
          title: 'GST ఇన్వాయిసింగ్',
          description: 'సెకన్లలో GST-అనుకూల ఇన్వాయిస్‌లను రూపొందించడానికి రూపొందించబడింది. ఖచ్చితమైన స్థానిక అనుకూలతతో పన్ను రేట్లను ఆటో-లెక్కించండి.'
        },
        inventory: {
          title: 'ఇన్వెంటరీ సింక్',
          description: 'మల్టీ-సిటీ గిడ్డంగులలో నిజ-సమయ స్టాక్ స్థాయిలను ట్రాక్ చేయండి. ఇన్వెంటరీ ఆరోగ్యంపై ప్రిడిక్టివ్ అలర్ట్‌లు.'
        },
        intelligence: {
          title: 'ట్రేడ్ ఇంటెలిజెన్స్',
          description: 'మా స్థానిక ఆర్కిటెక్చర్‌తో అధునాతన P&L, నగదు ప్రవాహం మరియు పన్ను నివేదికలను రూపొందించండి.'
        },
        mobile: {
          title: 'ఏకీకృత మొబైల్',
          description: 'మీ ఫోన్ నుండి మీ మొత్తం ఎంటర్‌ప్రైజ్‌ను నిర్వహించండి. ఎంటర్‌ప్రైజ్ పవర్, వినియోగదారు సరళత.'
        }
      },
      learn_more: 'మరింత తెలుసుకోండి'
    },
    cta: {
      badge: 'ప్రీ-లాంచ్ యాక్సెస్',
      title: 'భవిష్యత్తు',
      subtitle: 'భారతీయ వాణిజ్యం.',
      description: "సోమా యొక్క ఎంటర్‌ప్రైజ్ ఆర్కిటెక్చర్‌ను అనుభవించే మొదటి వారిలో ఒకరు అవ్వండి. వేగం, స్కేల్ మరియు స్థానిక అనుకూలత కోసం నిర్మించబడింది.",
      btn_waitlist: 'వెయిట్‌లిస్ట్‌లో చేరండి',
      btn_features: 'ఫీచర్లను చూడండి',
      benefits: {
        early_access: 'ఎర్లీ యాక్సెస్',
        priority: 'ప్రాధాన్యత ఆన్‌బోర్డింగ్',
        updates: 'అప్‌డేట్‌లు చేర్చబడ్డాయి'
      }
    },
    differentiation: {
      badge: 'ఓమ్నిఛానల్ ఆర్కిటెక్చర్',
      title: 'ఎక్కడి నుండైనా',
      subtitle: 'వ్యాపారం చేయండి.',
      description: 'మీరు కస్టమర్‌తో మాట్లాడుతున్నప్పుడు మీ ఫోన్‌లో ఇన్‌వాయిస్‌ను ప్రారంభించి, తర్వాత మీ ల్యాప్‌టాప్‌లో పూర్తి చేసేలా రూపొందించబడింది. తక్కువ కనెక్టివిటీ ఉన్న ప్రాంతాల్లో కూడా డేటా అన్ని పరికరాల్లో తక్షణమే సమకాలీకరించబడుతుంది.',
      items: {
        mobile: {
          title: 'మొబైల్ ఫస్ట్',
          desc: 'భారతీయ మార్కెట్‌ప్లేస్‌లో హై-స్పీడ్ ట్రేడ్ కోసం రూపొందించబడింది.'
        },
        desktop: {
          title: 'డెస్క్‌టాప్ స్కేల్',
          desc: 'భారీ ఇన్వెంటరీ ఆపరేషన్లు మరియు బల్క్ ట్రేడ్ క్లియరింగ్.'
        },
        sync: {
          title: 'ఆఫ్‌లైన్ సింక్',
          desc: 'డేటా స్థానికంగా నిల్వ చేయబడుతుంది. మీరు కనెక్ట్ అయిన వెంటనే సింక్ జరుగుతుంది.'
        }
      },
      stats: {
        latency: { value: '< 1s', label: 'టార్గెట్ లేటెన్సీ' },
        uptime: { value: '99.9%', label: 'టార్గెట్ అప్‌టైమ్' },
        crypto: { value: 'AES-256', label: 'క్రిప్టో' }
      },
      sync_status: 'లైవ్ సింక్'
    },
    faq: {
      badge: 'జ్ఞాన నిధి',
      title: 'వివరాలను',
      subtitle: 'స్పష్టం చేయడం.',
      questions: {
        setup: {
          q: 'లాంచ్ అయిన తర్వాత సోమాను సెటప్ చేయడానికి ఎంత సమయం పడుతుంది?',
          a: 'సోమా 2 నిమిషాల్లోపు పూర్తిగా సెటప్ చేయడానికి రూపొందించబడింది. మీ వ్యాపార పేరు మరియు GST నంబర్‌ను జోడించండి, మరియు మీరు వెంటనే ఇన్‌వాయిస్‌లను సృష్టించడం ప్రారంభించవచ్చు. మేము Tally, Zoho లేదా స్ప్రెడ్‌షీట్‌ల నుండి ఉచిత మైగ్రేషన్ సహాయాన్ని కూడా అందించాలని ప్లాన్ చేస్తున్నాము.'
        },
        security: {
          q: 'నా వ్యాపార డేటా సురక్షితమేనా?',
          a: 'ఖచ్చితంగా. మేము మొత్తం డేటా కోసం బ్యాంక్-గ్రేడ్ 256-బిట్ ఎన్‌క్రిప్షన్‌ను అమలు చేస్తున్నాము. మీ సమాచారం బహుళ బ్యాకప్‌లతో భారతదేశంలోని సురక్షిత సర్వర్‌లలో నిల్వ చేయబడుతుంది. మేము ISO 27001 సర్టిఫైడ్ మరియు పూర్తిగా DPDP కంప్లైంట్ అయ్యేలా నిర్మిస్తున్నాము.'
        },
        knowledge: {
          q: 'నాకు ఏదైనా అకౌంటింగ్ లేదా సాంకేతిక పరిజ్ఞానం అవసరమా?',
          a: 'అస్సలు అవసరం లేదు. సోమా వ్యాపార యజమానుల కోసం రూపొందించబడింది, అకౌంటెంట్ల కోసం కాదు. మీరు వాట్సాప్ ఉపయోగించగలిగితే, మీరు సోమాను ఉపయోగించగలరు. మేము అన్ని క్లిష్టమైన GST గణనలు, పన్ను వర్గీకరణలు మరియు అనుకూలత అవసరాలను స్వయంచాలకంగా నిర్వహిస్తాము.'
        },
        offline: {
          q: 'నాకు ఇంటర్నెట్ కనెక్షన్ లేకపోతే ఏమవుతుంది?',
          a: 'సోమా ఆఫ్‌లైన్‌లో కూడా పని చేయడానికి రూపొందించబడింది. మీరు మా మొబైల్ యాప్‌లో ఇన్‌వాయిస్‌లను సృష్టించడం, ఇన్వెంటరీని అప్‌డేట్ చేయడం మరియు విక్రయాలను రికార్డ్ చేయడం కొనసాగించవచ్చు. మీరు ఆన్‌లైన్‌లోకి వచ్చిన వెంటనే, ప్రతిదీ మీ అన్ని పరికరాల్లో స్వయంచాలకంగా సమకాలీకరించబడుతుంది.'
        },
        migration: {
          q: 'నేను Tally నుండి నా ప్రస్తుత డేటాను మైగ్రేట్ చేయవచ్చా?',
          a: 'అవును! మేము Tally, Zoho Books లేదా Excel స్ప్రెడ్‌షీట్‌ల నుండి మీ కస్టమర్ డేటా, ఉత్పత్తి కేటలాగ్ మరియు చారిత్రక లావాదేవీలను సజావుగా నిర్వహించడానికి దిగుమతి సాధనాలను నిర్మిస్తున్నాము.'
        }
      },
      cta: {
        title: 'ఆర్కిటెక్చరల్ సపోర్ట్',
        link: 'మా ఇంజనీర్లను సంప్రదించండి'
      }
    },
    testimonials: {
      badge: 'మా దృష్టి',
      title: 'ప్రతి భారతీయ వ్యాపారం',
      subtitle: 'కోసం రూపకల్పన.',
      description: 'టోకు వ్యాపారుల నుండి తయారీదారుల వరకు, మీ ప్రత్యేక వాణిజ్య అవసరాలకు అనుగుణంగా సోమా రూపొందించబడుతోంది.',
      featured: {
        title: 'టోకు & పంపిణీ',
        description: 'బల్క్ ఇన్వెంటరీ, కాంప్లెక్స్ ప్రైసింగ్ టైర్లు మరియు క్రెడిట్ సైకిళ్లను సులభంగా నిర్వహించండి. సోమా వాల్యూమ్‌ను నిర్వహించడానికి నిర్మించబడింది కాబట్టి మీరు వాణిజ్యంపై దృష్టి పెట్టవచ్చు.',
        badge: {
          title: 'టోకు',
          desc: 'అధిక వాల్యూమ్ • తక్కువ మార్జిన్'
        },
        stats: {
          inventory: { label: 'ఇన్వెంటరీ', value: 'బ్యాచ్ ట్రాకింగ్' },
          pricing: { label: 'ధరలు', value: 'మల్టీ-టైర్' },
          finance: { label: 'ఫైనాన్స్', value: 'క్రెడిట్ నిర్వహణ' }
        }
      },
      industries: {
        manufacturing: {
          title: 'తయారీ',
          description: 'ముడి పదార్థాలు, బిల్ ఆఫ్ మెటీరియల్స్ (BOM) మరియు ఉత్పత్తి ఖర్చుల యొక్క ఖచ్చితమైన ట్రాకింగ్‌ను లక్ష్యంగా చేసుకుంది.'
        },
        retail: {
          title: 'రిటైల్ చెయిన్స్',
          description: 'ప్లాన్ చేసిన ఏకీకృత పాయింట్ ఆఫ్ సేల్ (POS), బార్‌కోడ్ స్కానింగ్ మరియు నిజ-సమయ మల్టీ-స్టోర్ సమకాలీకరణ.'
        },
        service: {
          title: 'సేవా ప్రదాతలు',
          description: 'ప్రాజెక్ట్-ఆధారిత బిల్లింగ్, టైమ్ ట్రాకింగ్ మరియు ఆటోమేటెడ్ ఖర్చు నిర్వహణ కోసం రూపొందించబడింది.'
        }
      }
    },
  },
  features_page: {
      badge: 'SME OS కోర్ ఫీచర్లు',
      title: 'వీరి కోసం',
      subtitle: 'నిర్మించబడింది ఆగని SME.',
      description: 'ఆధునిక SMEల సంక్లిష్టతలను పరిష్కరించడానికి సోమా పునాది నుండి నిర్మించబడుతోంది. ఒకే ప్లాట్‌ఫామ్‌లో GSTని ఆటోమేట్ చేయండి, ఇన్వెంటరీని ట్రాక్ చేయండి మరియు నిజ-సమయ అంతర్దృష్టులను పొందండి.',
      cta_waitlist: 'వెయిట్‌లిస్ట్‌లో చేరండి',
      cta_learn_more: 'మరింత తెలుసుకోండి',
      engineered_workflows: 'ఇంజనీర్డ్ వర్క్‌ఫ్లోలు',
      testimonial: {
        quote: '"చివరగా, భారతీయ వాణిజ్యం యొక్క సంక్లిష్టతను అర్థం చేసుకునే వ్యాపార OS. మేము మా కార్యకలాపాలను సోమాకు మార్చడానికి ఆసక్తిగా ఎదురుచూస్తున్నాము."',
        author: 'అంకిత్ వర్ష్నీ',
        role: 'CEO, వర్ష్నీ టెక్స్‌టైల్స్ (బీటా పార్టనర్)'
      },
      final_cta: {
        title: 'భవిష్యత్తును అనుభవించడానికి సిద్ధంగా ఉన్నారా?',
        description: 'భారతీయ SME కార్యకలాపాలను పునర్నిర్వచించే ప్లాట్‌ఫామ్‌ను యాక్సెస్ చేసే మొదటి వారిలో ఉండండి. ఈ రోజే ఎర్లీ యాక్సెస్ కోసం అభ్యర్థించండి.',
        request_access: 'యాక్సెస్ అభ్యర్థించండి',
        view_plans: 'ప్లాన్‌లను చూడండి',
        footer: 'లోకల్-ఫస్ట్ • GST కంప్లైంట్ • ఎంటర్‌ప్రైజ్ స్కేల్'
      },
      features: {
        gst: {
          title: 'GST అనుకూలత',
          description: 'భారతీయ పన్ను పర్యావరణ వ్యవస్థ కోసం రూపొందించబడిన ఆటోమేటెడ్ GST ఫైలింగ్, ఇన్వాయిస్ జనరేషన్ మరియు కంప్లైయన్స్ ట్రాకింగ్.',
          benefits: {
            filing: 'ఆటోమేటెడ్ GSTR ఫైలింగ్',
            alerts: 'రియల్-టైమ్ కంప్లైయన్స్ అలర్ట్స్',
            validation: 'ఇన్వాయిస్ వాలిడేషన్'
          }
        },
        inventory: {
          title: 'ఇన్వెంటరీ సింక్',
          description: 'స్మార్ట్ రీఆర్డర్ పాయింట్లు మరియు అనలిటిక్స్‌తో బహుళ ప్రదేశాలలో నిజ-సమయ ఇన్వెంటరీ ట్రాకింగ్.',
          benefits: {
            tracking: 'మల్టీ-లొకేషన్ ట్రాకింగ్',
            alerts: 'ఆటోమేటెడ్ రీఆర్డర్ అలర్ట్స్',
            analytics: 'స్టాక్ మూవ్మెంట్ అనలిటిక్స్'
          }
        },
        analytics: {
          title: 'స్మార్ట్ అనలిటిక్స్',
          description: 'ఆటోమేటెడ్ P&L మరియు నగదు ప్రవాహ నివేదికలతో మీ వ్యాపార పనితీరుపై లోతైన అంతర్దృష్టులను పొందండి.',
          benefits: {
            pl: 'P&L స్టేట్‌మెంట్‌లు',
            cashflow: 'నగదు ప్రవాహ విశ్లేషణ',
            tax: 'పన్ను ఆప్టిమైజేషన్ అంతర్దృష్టులు'
          }
        },
        crm: {
          title: 'కస్టమర్ CRM',
          description: 'చరిత్ర ట్రాకింగ్ మరియు స్మార్ట్ ఎంగేజ్‌మెంట్ ద్వారా మీ కస్టమర్‌లతో శాశ్వత సంబంధాలను పెంచుకోండి.',
          benefits: {
            profiles: 'కస్టమర్ ప్రొఫైల్స్',
            history: 'ఆర్డర్ చరిత్ర',
            logs: 'కమ్యూనికేషన్ లాగ్స్'
          }
        },
        global: {
          title: 'గ్లోబల్ కామర్స్',
          description: 'మల్టీ-కరెన్సీ మద్దతు మరియు FEMA-అనుకూల ఇన్వాయిసింగ్ వర్క్‌ఫ్లోలతో ప్రపంచవ్యాప్తంగా విస్తరించండి.',
          benefits: {
            rates: 'రియల్-టైమ్ ఎక్స్ఛేంజ్ రేట్లు',
            invoicing: 'మల్టీ-కరెన్సీ ఇన్వాయిసింగ్',
            compliance: 'FEMA అనుకూలత'
          }
        },
        security: {
          title: 'బ్యాంక్-గ్రేడ్ సెక్యూరిటీ',
          description: 'మీ వ్యాపార డేటా అత్యున్నత ఎన్‌క్రిప్షన్ ప్రమాణాలు మరియు స్థానిక అనుకూలతతో రక్షించబడుతుంది.',
          benefits: {
            encryption: 'ఎండ్-టు-ఎండ్ ఎన్‌క్రిప్షన్',
            backups: 'రెగ్యులర్ బ్యాకప్‌లు',
            compliance: 'భారతీయ DPDP అనుకూలత'
          }
        }
      }
    },
    pricing_page: {
      badge: 'పారదర్శక ధరలు',
      title: 'సరళమైన, పారదర్శక ధరలు',
      subtitle: 'దాచిన ఫీజులు లేవు.',
      description: '14-రోజుల ఉచిత ట్రయల్‌తో ప్రారంభించండి. క్రెడిట్ కార్డ్ అవసరం లేదు.',
      billing: {
        monthly: 'నెలవారీ',
        yearly: 'వార్షిక',
        save: '20% ఆదా చేయండి'
      },
      per_month: '/నెలకు',
      yearly_discount: 'వార్షిక తగ్గింపు',
      plans: {
        features_title: 'చేర్చబడిన ఫీచర్లు',
        per_month: '/నెల',
        recommended: 'స్కేల్ కోసం సిఫార్సు చేయబడింది',
        starter: {
          name: 'స్టార్టర్',
          description: 'చిన్న వ్యాపారాలు మరియు అభివృద్ధి చెందుతున్న స్టార్టప్‌లకు సరైనది',
          cta: 'వెయిట్‌లిస్ట్‌లో చేరండి',
          features: {
            invoices: 'నెలకు 100 ఇన్వాయిస్‌లు',
            gst: 'ప్రాథమిక GST అనుకూలత',
            inventory: 'సింగిల్ లొకేషన్ ఇన్వెంటరీ',
            support: 'ఇమెయిల్ మద్దతు',
            reporting: 'ప్రాథమిక రిపోర్టింగ్',
            mobile: 'మొబైల్ యాప్ యాక్సెస్'
          }
        },
        professional: {
          name: 'ప్రొఫెషనల్',
          description: 'సంక్లిష్ట అవసరాలు కలిగిన అభివృద్ధి చెందుతున్న వ్యాపారాలకు ఆదర్శం',
          cta: 'వెయిట్‌లిస్ట్‌లో చేరండి',
          features: {
            invoices: 'అపరిమిత ఇన్వాయిస్‌లు',
            gst: 'అధునాతన GST అనుకూలత',
            inventory: 'మల్టీ-లొకేషన్ ఇన్వెంటరీ',
            support: 'ప్రాధాన్యత మద్దతు',
            analytics: 'అధునాతన అనలిటిక్స్',
            api: 'API యాక్సెస్',
            integrations: 'కస్టమ్ ఇంటిగ్రేషన్లు',
            users: 'మల్టీ-యూజర్ యాక్సెస్'
          }
        },
        enterprise: {
          name: 'ఎంటర్‌ప్రైజ్',
          description: 'టీమ్ వర్క్‌ఫ్లోలతో కూడిన భారీ తరహా వ్యాపారాల కోసం',
          cta: 'ఎర్లీ యాక్సెస్ కోసం సంప్రదించండి',
          features: {
            all_pro: 'ప్రొఫెషనల్‌లో అన్నీ',
            manager: 'డెడికేటెడ్ అకౌంట్ మేనేజర్',
            workflows: 'కస్టమ్ వర్క్‌ఫ్లోలు',
            security: 'అధునాతన భద్రతా ఫీచర్లు',
            whitelabel: 'వైట్-లేబుల్ ఎంపికలు',
            access: 'రోల్-బేస్డ్ యాక్సెస్',
            reporting: 'కస్టమ్ రిపోర్టింగ్',
            deployment: 'ఆన్-ప్రిమైజ్ డిప్లాయ్‌మెంట్'
          }
        }
      },
      faq: {
        badge: 'FAQ',
        title: 'ప్రశ్నలు',
        subtitle: 'బిల్లింగ్ మరియు ధరల గురించి మీరు తెలుసుకోవలసిన ప్రతిదీ.',
        questions: {
          trial: {
            q: 'ఉచిత ట్రయల్ ఉంటుందా?',
            a: 'అవును! లాంచ్ అయిన తర్వాత, అన్ని ప్లాన్‌లు 14-రోజుల ఉచిత ట్రయల్‌తో వస్తాయి. మీరు అన్ని ఫీచర్‌లకు పూర్తి యాక్సెస్‌ను పొందుతారు, కాబట్టి సోమా మీ వ్యాపారానికి తెచ్చే విలువను మీరు చూడవచ్చు. క్రెడిట్ కార్డ్ అవసరం లేదు.'
          },
          change: {
            q: 'నేను ఎప్పుడైనా ప్లాన్‌లను మార్చవచ్చా?',
            a: 'ఖచ్చితంగా. మీరు ఎప్పుడైనా మీ ప్లాన్‌ను అప్‌గ్రేడ్ లేదా డౌన్‌గ్రేడ్ చేయవచ్చు. మీరు అప్‌గ్రేడ్ చేసినప్పుడు, కొత్త ఫీచర్లు వెంటనే అందుబాటులో ఉంటాయి.'
          },
          payment: {
            q: 'ఏ చెల్లింపు పద్ధతులు ఆమోదించబడతాయి?',
            a: 'మేము అన్ని ప్రధాన క్రెడిట్ కార్డ్‌లు, డెబిట్ కార్డ్‌లు, UPI, నెట్ బ్యాంకింగ్ మరియు PhonePe, Paytm మరియు Google Payతో సహా భారతదేశంలో ప్రసిద్ధ డిజిటల్ వాలెట్‌లను ఆమోదించాలని ప్లాన్ చేస్తున్నాము.'
          },
          security: {
            q: 'నా డేటా సురక్షితమేనా?',
            a: 'అవును, మేము ఎంటర్‌ప్రైజ్-గ్రేడ్ 256-బిట్ SSL ఎన్‌క్రిప్షన్‌ను ఉపయోగిస్తాము. మీ వ్యాపార డేటా సురక్షితంగా ఉందని నిర్ధారించడానికి మేము SOC2 కంప్లైంట్ మరియు అన్ని భారతీయ డేటా రక్షణ నిబంధనలను (DPDP) అనుసరిస్తున్నాము.'
          }
        }
      },
      final_cta: {
        title: 'సిద్ధంగా ఉన్నారా',
        subtitle: 'భారీ స్కేల్ కోసం?',
        book_call: 'ఆర్కిటెక్చర్ కాల్ బుక్ చేయండి',
        contact_sales: 'సేల్స్‌ను సంప్రదించండి',
        footer: 'సోమాను డిప్లాయ్ చేయండి. లెగసీని నిర్మించండి.'
      }
    },
  solutions_page: {
      badge: 'పరిశ్రమ నిర్దిష్ట DNA',
      title: 'కస్టమ్ మేడ్',
      subtitle: 'మీ స్కేల్ కోసం.',
      description: 'సాధారణ సాఫ్ట్‌వేర్ విఫలమవుతుంది ఎందుకంటే మీ వ్యాపారం ప్రత్యేకమైనది. సోమా మీ పరిశ్రమ నిర్దిష్ట వర్క్‌ఫ్లోలకు అనుగుణంగా ఉంటుంది.',
      cta_contact: 'సేల్స్‌ను సంప్రదించండి',
      cta_case_studies: 'కేస్ స్టడీస్ చూడండి',
      core_workflow: 'కోర్ వర్క్‌ఫ్లో భాగాలు',
      top_users: 'టాప్ ఇండస్ట్రీ యూజర్లు',
      validated_results: 'ధృవీకరించబడిన ఫలితాలు',
      deployment: 'ఎంటర్‌ప్రైజ్ డిప్లాయ్‌మెంట్',
      built_for_scale: 'సంక్లిష్టమైన భారతీయ స్కేల్ కోసం నిర్మించబడింది.',
      industries: {
        retail: {
          title: 'Retail & E-commerce',
          description: 'యూనిఫైడ్ ఇన్వెంటరీ మరియు మల్టీ-ఛానల్ బిల్లింగ్‌తో మీ రిటైల్ వ్యాపారాన్ని స్కేల్ చేయండి.',
          features: {
            inventory: 'మల్టీ-ఛానల్ ఇన్వెంటరీ సింక్',
            pos: 'పాయింట్ ఆఫ్ సేల్ (POS) ఇంటిగ్రేషన్',
            loyalty: 'లాయల్టీ & గిఫ్ట్ కార్డ్స్',
            reordering: 'ఆటోమేటెడ్ స్టాక్ రీఆర్డరింగ్'
          },
          tags: {
            fashion: 'ఫ్యాషన్',
            electronics: 'ఎలక్ట్రానిక్స్',
            chains: 'రిటైల్ చైన్స్'
          },
          proof: {
            label: 'స్టాక్అవుట్ తగ్గింపు',
            company: 'ఫ్యాషన్ రిటైల్'
          }
        },
        manufacturing: {
          title: 'Manufacturing',
          description: 'స్మార్ట్ కాస్ట్ ట్రాకింగ్ మరియు ముడి పదార్థాల వర్క్‌ఫ్లోలతో ఉత్పత్తిని ఆప్టిమైజ్ చేయండి.',
          features: {
            planning: 'ప్రొడక్షన్ ప్లానింగ్ (MRP)',
            bom: 'BOM మేనేజ్‌మెంట్',
            waste: 'వేస్ట్ & స్క్రాపేజ్ ట్రాకింగ్',
            labor: 'లేబర్ కాస్ట్ అట్రిబ్యూషన్'
          },
          tags: {
            auto: 'ఆటో పార్ట్స్',
            textile: 'టెక్స్టైల్ మిల్స్',
            food: 'ఫుడ్ టెక్'
          },
          proof: {
            label: 'వేస్ట్ తగ్గింపు',
            company: 'మాన్యుఫ్యాక్చరింగ్'
          }
        },
        services: {
          title: 'Services & Agencies',
          description: 'క్లయింట్ బిల్లింగ్ మరియు ప్రాజెక్ట్ లాభదాయకతను సులభతరం చేయండి.',
          features: {
            accounting: 'ప్రాజెక్ట్-బేస్డ్ అకౌంటింగ్',
            portal: 'చెల్లింపుల కోసం క్లయింట్ పోర్టల్',
            tracking: 'టైమ్ ట్రాకింగ్',
            billing: 'రికరింగ్ సర్వీస్ బిల్లింగ్'
          },
          tags: {
            it: 'IT ఏజెన్సీలు',
            law: 'న్యాయ సంస్థలు',
            consulting: 'కన్సల్టింగ్'
          },
          proof: {
            label: 'వేగవంతమైన బిల్లింగ్',
            company: 'సర్వీస్ ఏజెన్సీ'
          }
        },
        healthcare: {
          title: 'Healthcare',
          description: 'మెడికల్ ప్రాక్టీసెస్ మరియు ల్యాబ్స్ కోసం కంప్లైయన్స్-రెడీ బ్యాక్-ఆఫీస్ టూల్స్.',
          features: {
            inventory: 'మెడికల్ ఇన్వెంటరీ కంట్రోల్',
            claims: 'ఇన్సూరెన్స్ క్లెయిమ్ ట్రాకింగ్',
            billing: 'పేషెంట్ బిల్లింగ్ ఆటోమేషన్',
            reporting: 'రెగ్యులేటరీ రిపోర్టింగ్'
          },
          tags: {
            clinics: 'క్లినిక్స్',
            pharmacies: 'ఫార్మసీలు',
            labs: 'ల్యాబ్స్'
          },
            proof: {
              label: 'బిల్లింగ్ ఖచ్చితత్వం',
              company: 'హెల్త్‌కేర్'
            }
          }
        },
        cta_section: {
          title_prefix: 'మీ సొల్యూషన్ DNA ను',
          title_suffix: 'కనుగొనడానికి సిద్ధంగా ఉన్నారా?',
          book_audit: 'ఆర్కిటెక్చర్ ఆడిట్ బుక్ చేయండి',
          talk_expert: 'నిపుణులతో మాట్లాడండి',
          footer_text: 'స్థానికంగా డిప్లాయ్ చేయండి. ప్రపంచవ్యాప్తంగా విస్తరించండి.'
        }
      },
  resources_page: {
    badge: 'సోమా నాలెడ్జ్ హబ్',
    title_prefix: 'అభివృద్ధి చెందడం',
    title_suffix: 'నేర్చుకోండి.',
    description: 'మీరు అన్‌స్టాపబుల్ భారతీయ SMEని నిర్మించడంలో సహాయపడటానికి ప్రత్యేకమైన గైడ్‌లు, పరిశ్రమ అంతర్దృష్టులు మరియు సాంకేతిక డాక్యుమెంటేషన్.',
    ledger: {
      title: 'ది లెడ్జర్',
      subtitle: 'SME స్కేల్ మరియు లోకల్-ఫస్ట్ ఆర్కిటెక్చర్‌పై ఒక పత్రిక.',
      cta: 'ఆర్కైవ్‌ను అన్వేషించండి'
    },
    implementation: {
      title_prefix: 'అమలు',
      title_suffix: 'ప్రావీణ్యం.',
      description: 'భారీ స్థాయి ఎంటర్‌ప్రైజ్ డిప్లాయ్‌మెంట్‌లు మరియు కస్టమ్ తయారీ వర్క్‌ఫ్లోల కోసం మా ఆర్కిటెక్ట్‌లు ప్రత్యేక సెషన్‌లను అందిస్తారు.',
      cta_training: 'శిక్షణను షెడ్యూల్ చేయండి',
      cta_support: 'సాంకేతిక మద్దతు',
      footer: 'ఆర్కిటెక్చర్ • ఇంటిగ్రేషన్ • స్కేల్'
    },
    cards: {
      quick_start: {
        title: "త్వరిత ప్రారంభ గైడ్",
        description: "సోమాతో మీ ప్రయాణాన్ని 10 నిమిషాల్లోపు ప్రారంభించడానికి మీకు కావలసినవన్నీ.",
        tag: "అవసరమైనవి"
      },
      mastering_gst: {
        title: "GST మాస్టరింగ్",
        description: "GSTR ఆటోమేషన్, ఈ-వే బిల్లులు మరియు స్థానిక పన్ను సమ్మతిపై లోతైన అవగాహన.",
        tag: "అప్‌డేట్ చేయబడింది 2026"
      },
      inventory_strategy: {
        title: "ఇన్వెంటరీ వ్యూహం",
        description: "V.K. ప్రింట్స్ సోమా యొక్క మల్టీ-లొకేషన్ సింక్‌ను ఉపయోగించి 400% వృద్ధిని ఎలా నిర్వహించింది.",
        tag: "కేస్ స్టడీ"
      },
      api_docs: {
        title: "API డాక్యుమెంటేషన్",
        description: "కస్టమ్ ఇంటిగ్రేషన్‌లను నిర్మించండి మరియు సోమా సామర్థ్యాలను విస్తరించండి.",
        tag: "సాంకేతిక"
      },
      community: {
        title: "కమ్యూనిటీ ఫోరమ్",
        description: "ఇతర వ్యాపార యజమానులు మరియు సోమా నిపుణులతో కనెక్ట్ అవ్వండి.",
        tag: "బాహ్య"
      },
      webinar: {
        title: "వెబినార్: GST 2026",
        description: "కొత్త పన్ను నిబంధనలపై మా తాజా సెషన్ రికార్డింగ్‌ను చూడండి.",
        tag: "కొత్తది"
      }
    }
  },
  // Layout translations
  layout: {
    navbar: {
      login: 'లాగిన్',
      get_started: 'ప్రారంభించండి',
      dashboard: 'డాష్‌బోర్డ్',
      links: {
        features: 'ఫీచర్లు',
        pricing: 'ధరలు',
        solutions: 'పరిష్కారాలు',
        resources: 'వనరులు'
      }
    },
    footer: {
      brand_desc: 'భారతీయ ఎంటర్‌ప్రైజెస్ స్కేల్ కోసం ఇంజనీరింగ్ చేసిన ప్రీమియం బిజినెస్ ఆపరేటింగ్ సిస్టమ్.',
      engineered_for: 'ఇంజనీర్డ్ ఫర్',
      excellence: 'ఎక్సలెన్స్',
      sections: {
        product: 'ఉత్పత్తి',
        company: 'కంపెనీ',
        resources: 'వనరులు',
        legal: 'చట్టపరమైన'
      },
      links: {
        features: 'ఫీచర్లు',
        pricing: 'ధరలు',
        solutions: 'పరిష్కారాలు',
        resources: 'వనరులు',
        about: 'గురించి',
        blog: 'బ్లాగ్',
        careers: 'కెరీర్లు',
        contact: 'సంప్రదించండి',
        docs: 'డాక్యుమెంటేషన్',
        help: 'సహాయ కేంద్రం',
        api: 'API రిఫరెన్స్',
        status: 'స్థితి',
        privacy: 'గోప్యత',
        terms: 'నిబంధనలు',
        security: 'భద్రత'
      },
      copyright: 'సోమా టెక్నాలజీస్. సర్వ హక్కులు ప్రత్యేకించబడ్డాయి.'
    }
  },
  // Common UI elements
  common: {
    loading: 'లోడ్ అవుతోంది...',
    save: 'సేవ్ చేయండి',
    cancel: 'రద్దు చేయండి',
    delete: 'తొలగించండి',
    edit: 'సవరించండి',
    add: 'జోడించండి',
    create: 'సృష్టించండి',
    update: 'అప్‌డేట్ చేయండి',
    search: 'వెతకండి',
    filter: 'ఫిల్టర్',
    export: 'ఎగుమతి',
    import: 'దిగుమతి',
    print: 'ప్రింట్',
    download: 'డౌన్‌లోడ్',
    upload: 'అప్‌లోడ్',
    submit: 'సమర్పించండి',
    reset: 'రీసెట్',
    clear: 'క్లియర్',
    confirm: 'నిర్ధారించండి',
    yes: 'అవును',
    no: 'లేదు',
    ok: 'సరే',
    close: 'మూసివేయండి',
    back: 'వెనుకకు',
    next: 'తదుపరి',
    previous: 'మునుపటి',
    finish: 'ముగించండి',
    continue: 'కొనసాగించండి',
    skip: 'దాటవేయండి',
    retry: 'మళ్లీ ప్రయత్నించండి',
    refresh: 'రిఫ్రెష్',
    view: 'చూడండి',
    details: 'వివరాలు',
    settings: 'సెట్టింగ్‌లు',
    help: 'సహాయం',
    about: 'గురించి',
    contact: 'సంప్రదించండి',
    support: 'మద్దతు',
    feedback: 'అభిప్రాయం',
    logout: 'లాగ్ అవుట్',
    login: 'లాగిన్',
    register: 'నమోదు',
    profile: 'ప్రొఫైల్',
    account: 'ఖాతా',
    dashboard: 'డాష్‌బోర్డ్',
    home: 'హోమ్',
    menu: 'మెనూ',
    navigation: 'నావిగేషన్',
    sidebar: 'సైడ్‌బార్',
    header: 'హెడర్',
    footer: 'ఫుటర్',
    content: 'కంటెంట్',
    main: 'ప్రధాన',
    section: 'విభాగం',
    page: 'పేజీ',
    tab: 'ట్యాబ్',
    panel: 'ప్యానెల్',
    modal: 'మోడల్',
    dialog: 'డైలాగ్',
    form: 'ఫారం',
    field: 'ఫీల్డ్',
    input: 'ఇన్‌పుట్',
    select: 'ఎంచుకోండి',
    option: 'ఎంపిక',
    checkbox: 'చెక్‌బాక్స్',
    radio: 'రేడియో',
    button: 'బటన్',
    link: 'లింక్',
    image: 'చిత్రం',
    icon: 'ఐకాన్',
    text: 'టెక్స్ట్',
    title: 'శీర్షిక',
    description: 'వివరణ',
    name: 'పేరు',
    email: 'ఇమెయిల్',
    phone: 'ఫోన్',
    address: 'చిరునామా',
    city: 'నగరం',
    state: 'రాష్ట్రం',
    country: 'దేశం',
    zipcode: 'పిన్ కోడ్',
    date: 'తేదీ',
    time: 'సమయం',
    datetime: 'తేదీ మరియు సమయం',
    status: 'స్థితి',
    type: 'రకం',
    category: 'వర్గం',
    priority: 'ప్రాధాన్యత',
    quantity: 'పరిమాణం',
    price: 'ధర',
    amount: 'మొత్తం',
    total: 'మొత్తం',
    subtotal: 'ఉప మొత్తం',
    tax: 'పన్ను',
    discount: 'తగ్గింపు',
    currency: 'కరెన్సీ',
    unit: 'యూనిట్',
    notes: 'గమనికలు',
    comments: 'వ్యాఖ్యలు',
    tags: 'ట్యాగ్‌లు',
    actions: 'చర్యలు',
    options: 'ఎంపికలు',
    preferences: 'ప్రాధాన్యతలు',
    configuration: 'కాన్ఫిగరేషన్',
    advanced: 'అధునాతన',
    basic: 'ప్రాథమిక',
    general: 'సాధారణ',
    security: 'భద్రత',
    privacy: 'గోప్యత',
    notifications: 'నోటిఫికేషన్‌లు',
    alerts: 'అలర్ట్‌లు',
    warnings: 'హెచ్చరికలు',
    errors: 'లోపాలు',
    success: 'విజయం',
    info: 'సమాచారం',
    tips: 'చిట్కాలు',
    guides: 'గైడ్‌లు',
    tutorials: 'ట్యుటోరియల్‌లు',
    documentation: 'డాక్యుమెంటేషన్',
    faq: 'తరచుగా అడిగే ప్రశ్నలు',
    terms: 'నిబంధనలు',
    conditions: 'షరతులు',
    policy: 'విధానం',
    agreement: 'ఒప్పందం',
    license: 'లైసెన్స్',
    version: 'వెర్షన్',
    active: 'క్రియాశీల',
    inactive: 'నిష్క్రియ',
    pending: 'పెండింగ్',
    completed: 'పూర్తయింది',
    failed: 'విఫలమైంది',
    cancelled: 'రద్దు చేయబడింది',
    approved: 'ఆమోదించబడింది',
    rejected: 'తిరస్కరించబడింది',
    draft: 'డ్రాఫ్ట్',
    published: 'ప్రచురించబడింది',
    archived: 'ఆర్కైవ్ చేయబడింది',
    deleted: 'తొలగించబడింది',
    new: 'కొత్త',
    old: 'పాత',
    recent: 'ఇటీవలి',
    latest: 'తాజా',
    popular: 'ప్రసిద్ధ',
    featured: 'ఫీచర్డ్',
    recommended: 'సిఫార్సు చేయబడిన',
    trending: 'ట్రెండింగ్',
    high: 'అధిక',
    medium: 'మధ్యమ',
    low: 'తక్కువ',
    urgent: 'అత్యవసర',
    normal: 'సాధారణ',
    critical: 'క్రిటికల్',
    important: 'ముఖ్యమైన',
    optional: 'ఐచ్ఛిక',
    required: 'అవసరమైన',
    mandatory: 'తప్పనిసరి',
    public: 'పబ్లిక్',
    private: 'ప్రైవేట్',
    shared: 'షేర్ చేయబడిన',
    personal: 'వ్యక్తిగత',
    business: 'వ్యాపారం',
    professional: 'వృత్తిపరమైన',
    enterprise: 'ఎంటర్‌ప్రైజ్',
    premium: 'ప్రీమియం',
    free: 'ఉచిత',
    paid: 'చెల్లింపు',
    trial: 'ట్రయల్',
    demo: 'డెమో',
    beta: 'బీటా',
    alpha: 'ఆల్ఫా',
    stable: 'స్థిరమైన',
    development: 'అభివృద్ధి',
    production: 'ఉత్పాదన',
    testing: 'పరీక్ష',
    staging: 'స్టేజింగ్',
    maintenance: 'నిర్వహణ',
    backup: 'బ్యాకప్',
    restore: 'పునరుద్ధరణ',
    sync: 'సింక్',
    migrate: 'మైగ్రేట్',
    transfer: 'బదిలీ',
    copy: 'కాపీ',
    move: 'తరలించు',
    duplicate: 'డూప్లికేట్',
    clone: 'క్లోన్',
    merge: 'మర్జ్',
    split: 'స్ప్లిట్',
    combine: 'కలపండి',
    separate: 'వేరు చేయండి',
    group: 'గ్రూప్',
    ungroup: 'అన్‌గ్రూప్',
    sort: 'సార్ట్',
    order: 'ఆర్డర్',
    arrange: 'అమర్చండి',
    organize: 'నిర్వహించండి',
    manage: 'నిర్వహించండి',
    control: 'నియంత్రణ',
    monitor: 'మానిటర్',
    track: 'ట్రాక్',
    analyze: 'విశ్లేషించండి',
    report: 'రిపోర్ట్',
    statistics: 'గణాంకాలు',
    metrics: 'మెట్రిక్స్',
    analytics: 'అనలిటిక్స్',
    insights: 'అంతర్దృష్టులు',
    trends: 'ట్రెండ్‌లు',
    patterns: 'నమూనాలు',
    data: 'డేటా',
    information: 'సమాచారం',
    content: 'కంటెంట్',
    media: 'మీడియా',
    files: 'ఫైల్‌లు',
    documents: 'డాక్యుమెంట్‌లు',
    images: 'చిత్రాలు',
    videos: 'వీడియోలు',
    audio: 'ఆడియో',
    attachments: 'అటాచ్‌మెంట్‌లు',
    downloads: 'డౌన్‌లోడ్‌లు',
    uploads: 'అప్‌లోడ్‌లు',
    storage: 'స్టోరేజ్',
    memory: 'మెమరీ',
    cache: 'కాష్',
    database: 'డేటాబేస్',
    server: 'సర్వర్',
    client: 'క్లయింట్',
    network: 'నెట్‌వర్క్',
    internet: 'ఇంటర్నెట్',
    connection: 'కనెక్షన్',
    bandwidth: 'బ్యాండ్‌విడ్త్',
    speed: 'వేగం',
    performance: 'పనితీరు',
    optimization: 'ఆప్టిమైజేషన్',
    efficiency: 'సామర్థ్యం',
    quality: 'నాణ్యత',
    reliability: 'విశ్వసనీయత',
    stability: 'స్థిరత్వం',
    safety: 'భద్రత',
    protection: 'రక్షణ',
    encryption: 'ఎన్‌క్రిప్షన్',
    authentication: 'ప్రమాణీకరణ',
    authorization: 'అధికారం',
    permission: 'అనుమతి',
    access: 'యాక్సెస్',
    rights: 'హక్కులు',
    privileges: 'అధికారాలు',
    roles: 'పాత్రలు',
    users: 'వినియోగదారులు',
    groups: 'గ్రూప్‌లు',
    teams: 'టీమ్‌లు',
    organizations: 'సంస్థలు',
    companies: 'కంపెనీలు',
    departments: 'విభాగాలు',
    divisions: 'డివిజన్‌లు',
    branches: 'శాఖలు',
    locations: 'స్థానాలు',
    regions: 'ప్రాంతాలు',
    countries: 'దేశాలు',
    languages: 'భాషలు',
    currencies: 'కరెన్సీలు',
    timezones: 'టైమ్‌జోన్‌లు',
    formats: 'ఫార్మాట్‌లు',
    templates: 'టెంప్లేట్‌లు',
    themes: 'థీమ్‌లు',
    styles: 'స్టైల్‌లు',
    layouts: 'లేఅవుట్‌లు',
    designs: 'డిజైన్‌లు',
    colors: 'రంగులు',
    fonts: 'ఫాంట్‌లు',
    sizes: 'పరిమాణాలు',
    dimensions: 'కొలతలు',
    positions: 'స్థానాలు',
    alignments: 'అలైన్‌మెంట్‌లు',
    margins: 'మార్జిన్‌లు',
    padding: 'ప్యాడింగ్',
    borders: 'బార్డర్‌లు',
    shadows: 'షాడోలు',
    effects: 'ఎఫెక్ట్‌లు',
    animations: 'యానిమేషన్‌లు',
    transitions: 'ట్రాన్సిషన్‌లు',
    interactions: 'ఇంటరాక్షన్‌లు',
    gestures: 'జెస్చర్‌లు',
    shortcuts: 'షార్ట్‌కట్‌లు',
    hotkeys: 'హాట్‌కీలు',
    commands: 'కమాండ్‌లు',
    functions: 'ఫంక్షన్‌లు',
    features: 'ఫీచర్‌లు',
    capabilities: 'సామర్థ్యాలు',
    tools: 'టూల్స్',
    utilities: 'యుటిలిటీలు',
    widgets: 'విడ్జెట్‌లు',
    components: 'కాంపోనెంట్‌లు',
    modules: 'మాడ్యూల్‌లు',
    plugins: 'ప్లగిన్‌లు',
    extensions: 'ఎక్స్‌టెన్షన్‌లు',
    addons: 'యాడ్‌ఆన్‌లు',
    integrations: 'ఇంటిగ్రేషన్‌లు',
    connections: 'కనెక్షన్‌లు',
    apis: 'ఏపిఐలు',
    services: 'సేవలు',
    applications: 'అప్లికేషన్‌లు',
    software: 'సాఫ్ట్‌వేర్',
    hardware: 'హార్డ్‌వేర్',
    devices: 'పరికరాలు',
    platforms: 'ప్లాట్‌ఫామ్‌లు',
    systems: 'సిస్టమ్‌లు',
    frameworks: 'ఫ్రేమ్‌వర్క్‌లు',
    libraries: 'లైబ్రరీలు',
    packages: 'ప్యాకేజీలు',
    dependencies: 'డిపెండెన్సీలు',
    requirements: 'అవసరాలు',
    specifications: 'స్పెసిఫికేషన్‌లు',
    standards: 'ప్రమాణాలు',
    protocols: 'ప్రోటోకాల్‌లు',
    schemas: 'స్కీమాలు',
    structures: 'నిర్మాణాలు',
    models: 'మోడల్‌లు',
    entities: 'ఎంటిటీలు',
    objects: 'ఆబ్జెక్ట్‌లు',
    items: 'ఐటమ్‌లు',
    elements: 'ఎలిమెంట్‌లు',
    parts: 'భాగాలు',
    pieces: 'ముక్కలు',
    fragments: 'ఫ్రాగ్మెంట్‌లు',
    sections: 'విభాగాలు',
    chapters: 'అధ్యాయాలు',
    pages: 'పేజీలు',
    articles: 'వ్యాసాలు',
    posts: 'పోస్ట్‌లు',
    entries: 'ఎంట్రీలు',
    records: 'రికార్డ్‌లు',
    logs: 'లాగ్‌లు',
    history: 'చరిత్ర',
    timeline: 'టైమ్‌లైన్',
    schedule: 'షెడ్యూల్',
    calendar: 'క్యాలెండర్',
    events: 'ఈవెంట్‌లు',
    appointments: 'అపాయింట్‌మెంట్‌లు',
    meetings: 'మీటింగ్‌లు',
    conferences: 'కాన్ఫరెన్స్‌లు',
    calls: 'కాల్‌లు',
    messages: 'మెసేజ్‌లు',
    emails: 'ఇమెయిల్‌లు',
    reminders: 'రిమైండర్‌లు',
    tasks: 'టాస్క్‌లు',
    todos: 'టూ-డూలు',
    projects: 'ప్రాజెక్ట్‌లు',
    workflows: 'వర్క్‌ఫ్లోలు',
    processes: 'ప్రాసెస్‌లు',
    procedures: 'ప్రొసీజర్‌లు',
    steps: 'దశలు',
    stages: 'దశలు',
    phases: 'దశలు',
    milestones: 'మైల్‌స్టోన్‌లు',
    deadlines: 'డెడ్‌లైన్‌లు',
    goals: 'లక్ష్యాలు',
    objectives: 'ఉద్దేశ్యాలు',
    targets: 'లక్ష్యాలు',
    achievements: 'సాధనలు',
    results: 'ఫలితాలు',
    outcomes: 'ఫలితాలు',
    outputs: 'అవుట్‌పుట్‌లు',
    inputs: 'ఇన్‌పుట్‌లు',
    resources: 'వనరులు',
    assets: 'ఆస్తులు',
    materials: 'మెటీరియల్‌లు',
    supplies: 'సప్లైలు',
    equipment: 'పరికరాలు',
    instruments: 'పరికరాలు',
    machines: 'యంత్రాలు',
    vehicles: 'వాహనాలు',
    facilities: 'సౌకర్యాలు',
    buildings: 'భవనాలు',
    rooms: 'గదులు',
    spaces: 'స్థలాలు',
    areas: 'ప్రాంతాలు',
    zones: 'జోన్‌లు',
    done: 'పూర్తయింది',
    undone: 'అసంపూర్ణ',
    accomplished: 'సాధించబడింది',
    unaccomplished: 'సాధించబడలేదు'
  },

  // Navigation
  navigation: {
    home: 'హోమ్',
    dashboard: 'డాష్‌బోర్డ్',
    inventory: 'ఇన్వెంటరీ',
    orders: 'ఆర్డర్‌లు',
    customers: 'కస్టమర్‌లు',
    suppliers: 'సప్లయర్‌లు',
    purchases: 'కొనుగోలులు',
    analytics: 'అనలిటిక్స్',
    reports: 'రిపోర్ట్‌లు',
    settings: 'సెట్టింగ్‌లు',
    profile: 'ప్రొఫైల్',
    logout: 'లాగ్ అవుట్',
    help: 'సహాయం',
    support: 'మద్దతు'
  },

  // Authentication
  auth: {
    login: 'లాగిన్',
    register: 'రిజిస్టర్',
    logout: 'లాగ్ అవుట్',
    forgotPassword: 'పాస్‌వర్డ్ మర్చిపోయారా',
    resetPassword: 'పాస్‌వర్డ్ రీసెట్',
    changePassword: 'పాస్‌వర్డ్ మార్చండి',
    email: 'ఇమెయిల్',
    password: 'పాస్‌వర్డ్',
    confirmPassword: 'పాస్‌వర్డ్ నిర్ధారణ',
    rememberMe: 'నన్ను గుర్తుంచుకోండి',
    loginButton: 'సైన్ ఇన్',
    registerButton: 'సైన్ అప్',
    alreadyHaveAccount: 'ఇప్పటికే ఖాతా ఉందా?',
    dontHaveAccount: 'ఖాతా లేదా?',
    signInHere: 'ఇక్కడ సైన్ ఇన్ చేయండి',
    signUpHere: 'ఇక్కడ సైన్ అప్ చేయండి',
    invalidCredentials: 'తప్పుడు ఇమెయిల్ లేదా పాస్‌వర్డ్',
    accountCreated: 'ఖాతా విజయవంతంగా సృష్టించబడింది',
    passwordResetSent: 'పాస్‌వర్డ్ రీసెట్ లింక్ మీ ఇమెయిల్‌కు పంపబడింది',
    passwordChanged: 'పాస్‌వర్డ్ విజయవంతంగా మార్చబడింది',
    login_page: {
      title: 'ఎంటర్‌ప్రైజ్ ఆపరేటింగ్ సిస్టమ్.',
      features: {
        speed: { title: 'లోకల్ స్పీడ్', desc: 'భారతీయ మార్కెట్‌ప్లేస్ కోసం నిర్మించిన అధిక-పనితీరు ఆర్కిటెక్చర్.' },
        trust: { title: 'ఎన్‌క్రిప్టెడ్ ట్రస్ట్', desc: 'మీ సున్నితమైన ఆర్థిక డేటా కోసం బ్యాంక్-గ్రేడ్ భద్రతా ప్రోటోకాల్‌లు.' }
      },
      serving: '10,000+ భారతీయ ఎంటర్‌ప్రైజెస్ కోసం',
      welcome: 'స్వాగతం.',
      subtitle: 'అధీకృత యాక్సెస్ మాత్రమే. దయచేసి మీ వివరాలను ధృవీకరించండి.',
      email_label: 'ఇమెయిల్ ఆర్కిటెక్చర్',
      password_label: 'సెక్యూరిటీ కీ',
      reset_access: 'యాక్సెస్ రీసెట్ చేయండి',
      submit: 'డాష్‌బోర్డ్ ప్రారంభించండి',
      verifying: 'వివరాలను ధృవీకరిస్తోంది...',
      third_party: 'థర్డ్ పార్టీ ఆథ్',
      verify_google: 'Googleతో ధృవీకరించండి',
      no_account: 'ఖాతా లేదా?',
      open_account: 'ఎంటర్‌ప్రైజ్ ఖాతాను తెరవండి'
    },
    register_page: {
      title: 'ఎలైట్ టైర్‌లో చేరండి.',
      features: {
        gst: { title: 'GST ఆప్టిమైజ్డ్', desc: 'ఎంటర్‌ప్రైజ్-గ్రేడ్ కంప్లైయన్స్ ఇంజిన్.' },
        sync: { title: 'అటామిక్ సింక్', desc: 'పరికరాల్లో తక్షణ డేటా ప్రచారం.' }
      },
      testimonial: '"2 నుండి 20 స్థానాలకు విస్తరించడానికి మాకు అవసరమైన మౌలిక సదుపాయాలు సోమా."',
      testimonial_author: 'రాజేష్ కుమార్',
      testimonial_role: 'యజమాని, గ్లోబల్ ట్రేడర్స్',
      form_title: 'ఖాతా తెరవండి.',
      form_subtitle: 'ఎలైట్ 14-రోజుల ట్రయల్‌తో మీ వ్యాపార నిర్మాణాన్ని భద్రపరచండి.',
      labels: {
        first_name: 'మొదటి పేరు',
        last_name: 'చివరి పేరు',
        email: 'కార్పొరేట్ ఇమెయిల్',
        password: 'సెక్యూరిటీ కీ',
        confirm_password: 'కీ నిర్ధారణ',
        business_name: 'వ్యాపార గుర్తింపు',
        phone: 'ఫోన్ నంబర్',
        entity_type: 'ఎంటిటీ రకం',
        sector: 'రంగం'
      },
      placeholders: {
        select_type: 'రకాన్ని ఎంచుకోండి',
        select_industry: 'పరిశ్రమను ఎంచుకోండి'
      },
      submit: 'యాక్సెస్ అభ్యర్థించండి',
      already_registered: 'ఇప్పటికే నమోదు చేసుకున్నారా?',
      sign_in: 'అధీకృత సైన్ ఇన్'
    }
  },

  // Business Management


  // Inventory Management
  inventory: {
    items: 'ఐటమ్‌లు',
    item: 'ఐటమ్',
    product: 'ఉత్పత్తి',
    service: 'సేవ',
    sku: 'ఎస్కేయు',
    barcode: 'బార్‌కోడ్',
    category: 'వర్గం',
    brand: 'బ్రాండ్',
    unit: 'యూనిట్',
    quantity: 'పరిమాణం',
    price: 'ధర',
    cost: 'ఖర్చు',
    sellingPrice: 'అమ్మకపు ధర',
    purchasePrice: 'కొనుగోలు ధర',
    stock: 'స్టాక్',
    lowStock: 'తక్కువ స్టాక్',
    outOfStock: 'స్టాక్ లేదు',
    inStock: 'స్టాక్‌లో ఉంది',
    stockAlert: 'స్టాక్ అలర్ట్',
    reorderLevel: 'రీఆర్డర్ లెవల్',
    maxStock: 'గరిష్ట స్టాక్',
    minStock: 'కనిష్ట స్టాక్',
    addItem: 'ఐటమ్ జోడించండి',
    editItem: 'ఐటమ్ సవరించండి',
    deleteItem: 'ఐటమ్ తొలగించండి',
    bulkImport: 'బల్క్ ఇంపోర్ట్',
    bulkExport: 'బల్క్ ఎక్స్‌పోర్ట్',
    stockUpdate: 'స్టాక్ అప్‌డేట్',
    stockAdjustment: 'స్టాక్ అడ్జస్ట్‌మెంట్',
    stockTransfer: 'స్టాక్ ట్రాన్స్‌ఫర్'
  },

  // Time formatting
  time: {
    justNow: 'ఇప్పుడే',
    minutesAgo: '{{count}} నిమిషాల క్రితం',
    hoursAgo: '{{count}} గంటల క్రితం',
    daysAgo: '{{count}} రోజుల క్రితం',
    weeksAgo: '{{count}} వారాల క్రితం',
    monthsAgo: '{{count}} నెలల క్రితం',
    yearsAgo: '{{count}} సంవత్సరాల క్రితం'
  },

  // Pluralization
  items: {
    one: '{{count}} ఐటమ్',
    other: '{{count}} ఐటమ్‌లు'
  },

  customers: {
    one: '{{count}} కస్టమర్',
    other: '{{count}} కస్టమర్‌లు'
  },

  orders: {
    one: '{{count}} ఆర్డర్',
    other: '{{count}} ఆర్డర్‌లు'
  },

  // Mobile app translations merged
  dashboard: {
    dashboard: "డాష్‌బోర్డ్",
    business_overview: "వ్యాపార పరిశీలన",
    action_required: "చర్య అవసరం",
    profile_incomplete_message: "మీ వ్యాపార ప్రొఫైల్ అసంపూర్ణంగా ఉంది. దయచేసి కొనసాగించడానికి అవసరమైన వివరాలను అందించండి.",
    complete_profile: "ప్రొఫైల్‌ను పూర్తి చేయండి",
    quick_actions: "త్వరిత చర్యలు",
    add_sale: "అమ్మకాన్ని జోడించండి",
    manage_stock: "స్టాక్‌ను నిర్వహించండి",
    view_orders: "ఆర్డర్‌లను వీక్షించండి",
    todays_overview: "ఈ రోజు పరిశీలన",
    weeks_overview: "ఈ వారం పరిశీలన",
    months_overview: "ఈ నెల పరిశీలన",
    low_stock: "తక్కువ స్టాక్",
    business_management: "వ్యాపార నిర్వహణ",
    inventory_management_subtitle: "ఉత్పత్తులు మరియు స్టాక్‌ను నిర్వహించండి",
    order_management_subtitle: "ఆర్డర్‌లను ట్రాక్ చేయండి మరియు పూర్తి చేయండి",
    purchase_management_subtitle: "కొనుగోళ్లను ట్రాక్ చేయండి మరియు నిర్వహించండి",
    customer_management_subtitle: "కస్టమర్ సంబంధాలను నిర్వహించండి",
    supplier_management_subtitle: "సరఫరాదారు సంబంధాలను నిర్వహించండి",
    business_analytics_subtitle: "పనితీరు కొలమానాలను వీక్షించండి",
    welcome_back: "తిరిగి స్వాగతం",
    orders_need_attention: "శ్రద్ధ అవసరమైన ఆర్డర్లు",
    total_revenue: "మొత్తం ఆదాయం",
    active_orders: "యాక్టివ్ ఆర్డర్లు",
    stock_value: "స్టాక్ విలువ",
    total_customers: "మొత్తం కస్టమర్లు",
    live: "లైవ్",
    monthly_sales: "నెలవారీ అమ్మకాలు",
    view_details: "వివరాలను చూడండి",
    recent_orders: "ఇటీవలి ఆర్డర్లు",
    view_all: "అన్నీ చూడండి",
    order_id: "ఆర్డర్ ID",
    customer: "కస్టమర్",
    amount: "మొత్తం",
    status: "స్థితి",
    important_tasks: "ముఖ్యమైన పనులు",
    in_stock: "స్టాక్‌లో ఉంది",
    buy_more: "మరింత కొనండి",
    manage_inventory: "ఇన్వెంటరీ నిర్వహణ",
    goals: "లక్ష్యాలు",
    sales_goal: "అమ్మకాల లక్ష్యం",
    revenue_goal: "ఆదాయ లక్ష్యం",
    search_placeholder: "ఆర్డర్లు, కస్టమర్లు లేదా ఉత్పత్తులను వెతకండి...",
    loading: "లోడ్ అవుతోంది..."
  },
  analytics: {
    title: "విశ్లేషణలు",
    subtitle: "వ్యాపార నివేదికలు మరియు అంచనాలను వీక్షించండి",
    last_7_days: "గత 7 రోజులు",
    last_30_days: "గత 30 రోజులు",
    last_3_months: "గత 3 నెలలు",
    business_reports: "వ్యాపార నివేదికలు",
    sales_forecast: "అమ్మకాల అంచనా",
    reports_library: "నివేదికల లైబ్రరీ",
    total_revenue: "మొత్తం ఆదాయం",
    average_order_value: "సగటు ఆర్డర్ విలువ",
    growth_rate: "వృద్ధి రేటు",
    total_orders: "మొత్తం ఆర్డర్లు",
    sales_by_channel: "ఛానెల్ వారీగా అమ్మకాలు",
    sales_breakdown: "ఛానెల్ వారీగా అమ్మకాల విభజన",
    online_sales: "ఆన్‌లైన్ అమ్మకాలు",
    store_sales: "స్టోర్ అమ్మకాలు",
    wholesale_sales: "టోకు అమ్మకాలు",
    ai_suggestions: "AI సూచనలు",
    ai_insight_1: "ఈ త్రైమాసికంలో మీ సగటు ఆర్డర్ విలువ 15% పెరిగింది.",
    ai_insight_1_desc: "కొత్త ప్రీమియం ఫీచర్లు అమ్మకాలను పెంచాయి, అధిక ఆదాయానికి దోహదపడ్డాయి.",
    next_month: "వచ్చే నెల",
    next_3_months: "వచ్చే 3 నెలలు",
    accuracy: "ఖచ్చితత్వం",
    sales_growth: "అమ్మకాల వృద్ధి",
    sales_growth_subtitle: "రాబోయే నెలల అమ్మకాల అంచనా",
    search_reports: "నివేదిక టెంప్లేట్‌లను వెతకండి...",
    reports_available: "అందుబాటులో ఉన్న నివేదికలు",
    no_reports: "నివేదికలు లేవు",
    no_reports_desc: "మీ నివేదికలు ఇక్కడ కనిపిస్తాయి",
    report_name: "నివేదిక పేరు",
    system_default: "సిస్టమ్ డిఫాల్ట్",
    description: "వివరణ",
    actions: "చర్యలు",
    edit: "సవరించండి",
    generate: "సృష్టించండి"
  },
  settings: {
    settingsTitle: "సెట్టింగ్‌లు",
    inventorySection: "ఇన్వెంటరీ",
    lowStockThresholdLabel: "తక్కువ స్టాక్ థ్రెషోల్డ్",
    lowStockThresholdDescription: "హెచ్చరిక ట్రిగ్గర్ కావడానికి ముందు కనీస స్టాక్ స్థాయి.",
    stockAlertsLabel: "స్టాక్ హెచ్చరికలు",
    stockAlertsDescription: "తక్కువ స్టాక్ కోసం నోటిఫికేషన్‌లను స్వీకరించండి.",
    autoReorderLabel: "ఆటో రీ-ఆర్డర్",
    autoReorderDescription: "స్టాక్ తక్కువగా ఉన్నప్పుడు స్వయంచాలకంగా కొనుగోలు ఆర్డర్‌లను రూపొందించండి.",
    ordersSection: "ఆర్డర్‌లు",
    autoConfirmOrdersLabel: "ఆర్డర్‌లను స్వయంచాలకంగా నిర్ధారించండి",
    autoConfirmOrdersDescription: "ఇన్‌కమింగ్ ఆర్డర్‌లను స్వయంచాలకంగా ఆమోదించి, ప్రాసెస్ చేయండి.",
    defaultPaymentMethodLabel: "డిఫాల్ట్ చెల్లింపు పద్ధతి",
    defaultPaymentMethodDescription: "కొత్త ఆర్డర్‌ల కోసం డిఫాల్ట్ చెల్లింపు పద్ధతిని సెట్ చేయండి.",
    orderNumberPrefixLabel: "ఆర్డర్ నంబర్ ప్రిఫిక్స్",
    orderNumberPrefixDescription: "అన్ని ఆర్డర్ నంబర్‌ల కోసం అనుకూల ప్రిఫిక్స్ (ఉదా., 'ORD-').",
    invoicingSection: "ఇన్‌వాయిస్",
    autoGenerateInvoicesLabel: "ఇన్‌వాయిస్‌లను స్వయంచాలకంగా రూపొందించండి",
    autoGenerateInvoicesDescription: "ప్రతి ఆర్డర్ కోసం స్వయంచాలకంగా కొత్త ఇన్‌వాయిస్‌ను రూపొందించండి.",
    invoiceNumberPrefixLabel: "ఇన్‌వాయిస్ నంబర్ ప్రిఫిక్స్",
    invoiceNumberPrefixDescription: "అన్ని ఇన్‌వాయిస్ నంబర్‌ల కోసం అనుకూల ప్రిఫిక్స్ (ఉదా., 'INV-').",
    defaultTaxRateLabel: "డిఫాల్ట్ పన్ను రేటు (%)",
    defaultTaxRateDescription: "కొత్త ఇన్‌వాయిస్‌లకు వర్తించే డిఫాల్ట్ పన్ను రేటు.",
    paymentTermsLabel: "చెల్లింపు నిబంధనలు",
    paymentTermsDescription: "ఇన్‌వాయిస్‌ల కోసం డిఫాల్ట్ చెల్లింపు నిబంధనలు (ఉదా., 'నెట్ 30').",
    reportingSection: "రిపోర్టింగ్",
    autoEmailReportsLabel: "నివేదికలను స్వయంచాలకంగా ఇమెయిల్ చేయండి",
    autoEmailReportsDescription: "మీ ఇమెయిల్ చిరునామాకు షెడ్యూల్ చేసిన నివేదికలను పంపండి.",
    defaultReportPeriodLabel: "డిఫాల్ట్ నివేదిక వ్యవధి",
    defaultReportPeriodDescription: "అన్ని నివేదికల కోసం డిఫాల్ట్ వ్యవధిని సెట్ చేయండి (ఉదా., 'నెలవారీ', 'వారానికోసారి').",
    reportFormatLabel: "నివేదిక ఫార్మాట్",
    reportFormatDescription: "నివేదికల కోసం డిఫాల్ట్ ఫైల్ ఫార్మాట్‌ను ఎంచుకోండి (ఉదా., 'PDF', 'CSV').",
    loadSettingsError: "సెట్టింగ్‌లను లోడ్ చేయడంలో విఫలమైంది: {{message}}",
    updateFailedError: "నవీకరణ విఫలమైంది",
    invalidInputError: "చెల్లని ఇన్‌పుట్",
    enterValidNumberError: "దయచేసి చెల్లుబాటు అయ్యే సంఖ్యను నమోదు చేయండి.",
    selectOption: "ఎంచుకోండి",
    paymentMethodCash: "నగదు",
    paymentMethodCard: "కార్డ్",
    paymentMethodUPI: "UPI",
    paymentMethodBankTransfer: "బ్యాంక్ బదిలీ",
    reportPeriodDaily: "రోజువారీ",
    reportPeriodWeekly: "వారానికోసారి",
    reportPeriodMonthly: "నెలవారీ",
    reportPeriodQuarterly: "త్రైమాసికం",
    reportFormatPDF: "PDF",
    reportFormatExcel: "Excel",
    reportFormatCSV: "CSV",
    enterValuePlaceholder: "విలువను నమోదు చేయండి"
  },
  businessProfile: {
    business_profile: "వ్యాపార ప్రొఫైల్",
    no_business_profile: "వ్యాపార ప్రొఫైల్ లేదు",
    no_business_profile_description: "మీరు ఇంకా మీ వ్యాపార ప్రొఫైల్‌ను సెటప్ చేయనట్లు కనిపిస్తోంది.",
    create_business_profile: "వ్యాపార ప్రొఫైల్‌ను సృష్టించండి",
    flower_vendor: "పూల వ్యాపారి",
    grocery_store: "కిరాణా దుకాణం",
    textile_shop: "వస్త్ర దుకాణం",
    hardware_store: "హార్డ్‌వేర్ దుకాణం",
    electronics_shop: "ఎలక్ట్రానిక్స్ దుకాణం"
  },
  businessSettings: {
    businessSettings: "వ్యాపార సెట్టింగ్‌లు",
    currency: "కరెన్సీ",
    setCurrency: "మీ వ్యాపారం కోసం డిఫాల్ట్ కరెన్సీని సెట్ చేయండి.",
    language: "భాష",
    setLanguage: "మీ ఖాతా కోసం భాషను సెట్ చేయండి.",
    timezone: "సమయమండలం",
    setTimezone: "మీ వ్యాపారం కోసం సమయమండలాన్ని సెట్ చేయండి.",
    notifications: "ప్రకటనలు",
    lowStockAlerts: "తక్కువ స్టాక్ హెచ్చరికలు",
    lowStockDescription: "తక్కువ స్టాక్ ఉన్న వస్తువుల కోసం హెచ్చరికలను స్వీకరించండి.",
    expiringItems: "గడువు ముగిసే వస్తువులు",
    expiringItemsDescription: "గడువు తేదీకి దగ్గరగా ఉన్న వస్తువుల కోసం హెచ్చరికలను స్వీకరించండి.",
    orderUpdates: "ఆర్డర్ నవీకరణలు",
    orderUpdatesDescription: "కొత్త ఆర్డర్‌లు మరియు ఆర్డర్ స్థితి మార్పుల కోసం హెచ్చరికలను స్వీకరించండి.",
    select: "ఎంచుకోండి",
    updateFailed: "నవీకరణ విఫలమైంది",
    loadingError: "సెట్టింగ్‌లను లోడ్ చేయడంలో విఫలమైంది",
    inr: "భారత రూపాయి (INR)",
    usd: "సంయుక్త రాష్ట్రాల డాలర్ (USD)",
    en: "ఆంగ్ల",
    hi: "హిందీ",
    te: "తెలుగు",
    ta: "తమిళం",
    kn: "కన్నడ",
    ml: "మలయాళం",
    kolkata: "ఆసియా/కోల్‌కతా"
  },
  business_settings_page: {
      business_settings: "వ్యాపార సెట్టింగ్‌లు",
      manage_business_preferences: "మీ వ్యాపార ప్రాధాన్యతలు మరియు కాన్ఫిగరేషన్‌లను నిర్వహించండి",
      general_settings: "సాధారణ సెట్టింగ్‌లు",
      configure_general_settings: "ప్రాథమిక వ్యాపార సెట్టింగ్‌లను కాన్ఫిగర్ చేయండి",
      language: "భాష",
      currency: "కరెన్సీ",
      select_currency: "కరెన్సీని ఎంచుకోండి",
      timezone: "టైమ్‌జోన్",
      select_timezone: "టైమ్‌జోన్‌ను ఎంచుకోండి",
      notifications: "నోటిఫికేషన్లు",
      manage_notification_preferences: "మీ నోటిఫికేషన్ ప్రాధాన్యతలను నిర్వహించండి",
      low_stock_alerts: "తక్కువ స్టాక్ హెచ్చరికలు",
      low_stock_description: "ఇన్వెంటరీ తక్కువగా ఉన్నప్పుడు తెలియజేయబడుతుంది",
      expiring_items: "గడువు ముగుస్తున్న అంశాలు",
      expiring_items_description: "గడువు ముగుస్తున్న అంశాల గురించి తెలియజేయబడుతుంది",
      order_updates: "ఆర్డర్ నవీకరణలు",
      order_updates_description: "కొత్త ఆర్డర్‌లు మరియు స్థితి మార్పుల గురించి తెలియజేయబడుతుంది",
      saving: "సేవ్ చేస్తోంది...",
      save_changes: "మార్పులను సేవ్ చేయండి",
      failed_to_load_settings: "సెట్టింగ్‌లను లోడ్ చేయడంలో విఫలమైంది",
      settings_saved_successfully: "సెట్టింగ్‌లు విజయవంతంగా సేవ్ చేయబడ్డాయి",
      failed_to_save_settings: "సెట్టింగ్‌లను సేవ్ చేయడంలో విఫలమైంది"
    },

  profile: {
    profile: "ప్రొఫైల్",
    manage_your_account_settings: "మీ ఖాతా సెట్టింగ్‌లను నిర్వహించండి",
    active: "క్రియాశీలం",
    business: "వ్యాపారం",
    business_profile: "వ్యాపార ప్రొఫైల్",
    business_settings: "వ్యాపార సెట్టింగ్‌లు",
    subscription: "సబ్స్క్రిప్షన్",
    reports_and_analytics: "నివేదికలు & విశ్లేషణలు",
    account: "ఖాతా",
    edit_profile: "ప్రొఫైల్‌ను సవరించండి",
    security_and_privacy: "భద్రత & గోప్యత",
    settings: "సెట్టింగ్‌లు",
    preferences: "ప్రాధాన్యతలు",
    advance_view: "అడ్వాంస్డ్ వ్యూ",
    help_and_support: "సహాయం & మద్దతు",
    about_soma: "సోమా గురించి",
    sign_out: "సైన్ అవుట్ చేయండి",
    logout: "లాగ్ అవుట్",
    are_you_sure_you_want_to_logout: "మీరు ఖచ్చితంగా లాగ్ అవుట్ చేయాలనుకుంటున్నారా?"
  },
  business: {
    profile: "వ్యాపార ప్రొఫైల్",
    edit_profile: "ప్రొఫైల్ సవరించండి",
    create_profile: "వ్యాపార ప్రొఫైల్ సృష్టించండి",
    edit_business_profile: "వ్యాపార ప్రొఫైల్ సవరించండి",
    create_business_profile: "వ్యాపార ప్రొఫైల్ సృష్టించండి",
    no_profile_found: "వ్యాపార ప్రొఫైల్ కనుగొనబడలేదు",
    no_business_profile: "వ్యాపార ప్రొఫైల్ కనుగొనబడలేదు",
    no_business_profile_description: "మీరు ఇంకా మీ వ్యాపార ప్రొఫైల్‌ను సెటప్ చేయలేదు. అన్ని ఫీచర్‌లను అన్‌లాక్ చేయడానికి ఒకదాన్ని సృష్టించండి.",
    go_back: "వెనక్కి వెళ్ళండి",
    basic_info: "ప్రాథమిక సమాచారం",
    business_name: "వ్యాపారం పేరు",
    enter_name: "వ్యాపారం పేరు నమోదు చేయండి",
    business_type: "వ్యాపార రకం",
    select_type: "వ్యాపార రకాన్ని ఎంచుకోండి",
    email: "ఇమెయిల్",
    enter_email: "ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    phone: "ఫోన్",
    enter_phone: "ఫోన్ నంబర్‌ను నమోదు చేయండి",
    address: "చిరునామా",
    enter_address: "పూర్తి చిరునామాను నమోదు చేయండి",
    category: "వర్గం",
    select_category: "వర్గాన్ని ఎంచుకోండి",
    annual_turnover: "వార్షిక టర్నోవర్",
    select_turnover: "టర్నోవర్ పరిధిని ఎంచుకోండి",
    turnover_range_0_5L: "₹0 - ₹5 లక్షలు",
    turnover_range_5L_20L: "₹5 లక్షలు - ₹20 లక్షలు",
    turnover_range_20L_1Cr: "₹20 లక్షలు - ₹1 కోటి",
    turnover_range_1Cr_plus: "₹1 కోటి+",
    fetch_profile_error: "వ్యాపార ప్రొఫైల్ పొందడంలో విఫలమైంది",
    fetch_gst_error: "GST సెట్టింగ్‌లను పొందడంలో విఫలమైంది",
    toggle_gst_error: "GST ఫీచర్‌లను మార్చడంలో విఫలమైంది",
    update_gst_status_error: "GST స్థితిని నవీకరించడంలో విఫలమైంది",
    save_error: "మార్పులను సేవ్ చేయడంలో విఫలమైంది",
    error_saving: "సేవ్ చేస్తున్నప్పుడు లోపం సంభవించింది",
    profile_updated: "ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది",
    business_profile_not_found: "వ్యాపార ప్రొఫైల్ కనుగొనబడలేదు",
    saving: "సేవ్ చేస్తోంది...",
    save_changes: "మార్పులను సేవ్ చేయండి",
    cancel: "రద్దు చేయండి",
    gst_registered: "GST నమోదు చేయబడింది",
    gst_number: "GST సంఖ్య",
    registration_date: "నమోదు తేదీ",
    flower_vendor: "పూల వ్యాపారి",
    grocery_store: "కిరాణా దుకాణం",
    textile_shop: "వస్త్ర దుకాణం",
    hardware_store: "హార్డ్‌వేర్ దుకాణం",
    electronics_shop: "ఎలక్ట్రానిక్స్ దుకాణం",
    other: "ఇతర",
    retailer: "చిల్లర వర్తకుడు",
    wholesaler: "టోకు వర్తకుడు",
    manufacturer: "తయారీదారు",
    service_provider: "సేవా ప్రదాత",
    gst_configuration: "GST కాన్ఫిగరేషన్",
    enabled: "ప్రారంభించబడింది",
    disabled: "నిలిపివేయబడింది",
    gstin_number: "GSTIN సంఖ్య",
    gstin_placeholder: "22AAAAA0000A1Z5",
    gst_registration_date: "GST నమోదు తేదీ",
    default_cgst: "డిఫాల్ట్ CGST (%)",
    default_sgst: "డిఫాల్ట్ SGST (%)",
    default_igst: "డిఫాల్ట్ IGST (%)",
    auto_sync: "GST పోర్టల్‌తో ఇన్‌వాయిస్‌లను ఆటో-సింక్ చేయండి",
    business_settings: "వ్యాపార సెట్టింగ్‌లు",
    manage_business_preferences: "మీ వ్యాపార ప్రాధాన్యతలు మరియు కాన్ఫిగరేషన్‌లను నిర్వహించండి",
    general_settings: "సాధారణ సెట్టింగ్‌లు",
    configure_general_settings: "ప్రాథమిక వ్యాపార సెట్టింగ్‌లను కాన్ఫిగర్ చేయండి",
    language: "భాష",
    select_language: "భాషను ఎంచుకోండి",
    currency: "కరెన్సీ",
    select_currency: "కరెన్సీని ఎంచుకోండి",
    timezone: "సమయ క్షేత్రం",
    select_timezone: "సమయ క్షేత్రాన్ని ఎంచుకోండి",
    notifications: "నోటిఫికేషన్‌లు",
    manage_notification_preferences: "మీ నోటిఫికేషన్ ప్రాధాన్యతలను నిర్వహించండి",
    low_stock_alerts: "తక్కువ స్టాక్ హెచ్చరికలు",
    low_stock_description: "ఇన్వెంటరీ తక్కువగా ఉన్నప్పుడు నోటిఫికేషన్ పొందండి",
    expiring_items: "గడువు ముగుస్తున్న అంశాలు",
    expiring_items_description: "అంశాలు గడువు ముగింపు దశకు చేరుకున్నప్పుడు నోటిఫికేషన్ పొందండి",
    order_updates: "ఆర్డర్ అప్‌డేట్‌లు",
    order_updates_description: "కొత్త ఆర్డర్‌లు మరియు స్థితి మార్పుల గురించి నోటిఫికేషన్ పొందండి",
    save_changes: "మార్పులను సేవ్ చేయండి",
    saving: "సేవ్ చేస్తోంది...",
    cancel: "రద్దు చేయండి",
    create_profile_btn: "ప్రొఫైల్ సృష్టించండి",
    yes: "అవును",
    no: "కాదు",
    n_a: "వర్తించదు",
    settings_saved_successfully: "సెట్టింగ్‌లు విజయవంతంగా సేవ్ చేయబడ్డాయి",
    failed_to_save_settings: "సెట్టింగ్‌లను సేవ్ చేయడం విఫలమైంది",
    failed_to_load_settings: "సెట్టింగ్‌లను లోడ్ చేయడం విఫలమైంది",
    profile_updated: "ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది",
    business_profile_created: "వ్యాపార ప్రొఫైల్ విజయవంతంగా సృష్టించబడింది!",
    error_saving: "సేవ్ చేస్తున్నప్పుడు లోపం సంభవించింది",
    error_creating: "ప్రొఫైల్ సృష్టిస్తున్నప్పుడు లోపం సంభవించింది",
    could_not_fetch_business_profile: "వ్యాపార ప్రొఫైల్ పొందలేకపోయాము",
    business_profile_not_found: "వ్యాపార ప్రొఫైల్ కనుగొనబడలేదు",
    not_provided: "అందించబడలేదు",
    business_label: "వ్యాపారం"
  },
  profile_settings: {
    title: "సెట్టింగులు",
    description: "మీ ఖాతా మరియు ప్లాట్‌ఫారమ్ ప్రాధాన్యతలను నిర్వహించండి.",
    my_profile: "నా ప్రొఫైల్",
    my_profile_desc: "వ్యక్తిగత సమాచారం మరియు అవతార్",
    preferences: "ప్రాధాన్యతలు",
    preferences_desc: "థీమ్, భాష మరియు నోటిఫికేషన్‌లు",
    security_privacy: "భద్రత & గోప్యత",
    security_privacy_desc: "పాస్‌వర్డ్ మరియు యాక్సెస్ భద్రత",
    active_sessions: "యాక్టివ్ సెషన్‌లు",
    active_sessions_desc: "లాగిన్ అయిన పరికరాలను నిర్వహించండి",
    sign_out: "సైన్ అవుట్",
    profile_details: "ప్రొఫైల్ వివరాలు",
    profile_details_desc: "మీ ఫోటో మరియు వ్యక్తిగత సమాచారాన్ని అప్‌డేట్ చేయండి.",
    verified_account: "ధృవీకరించబడిన ఖాతా",
    premium_plan: "ప్రీమియం ప్లాన్",
    first_name: "మొదటి పేరు",
    last_name: "చివరి పేరు",
    email_address: "ఇమెయిల్ చిరునామా",
    save_profile_changes: "ప్రొఫైల్ మార్పులను సేవ్ చేయండి",
    saving: "సేవ్ చేస్తోంది...",
    preferences_title: "ప్రాధాన్యతలు",
    appearance: "స్వరూపం",
    theme: "థీమ్",
    select_theme: "థీమ్‌ను ఎంచుకోండి",
    light_mode: "లైట్ మోడ్",
    dark_mode: "డార్క్ మోడ్",
    system_default: "సిస్టమ్ డిఫాల్ట్",
    display_language: "ప్రదర్శన భాష",
    select_language: "భాషను ఎంచుకోండి",
    notifications: "నోటిఫికేషన్‌లు",
    email_notifications: "ఇమెయిల్ నోటిఫికేషన్‌లు",
    email_notifications_desc: "ఇమెయిల్ ద్వారా నవీకరణలను స్వీకరించండి",
    push_notifications: "పుష్ నోటిఫికేషన్‌లు",
    push_notifications_desc: "బ్రౌజర్ నోటిఫికేషన్‌లను స్వీకరించండి",
    sms_notifications: "SMS నోటిఫికేషన్‌లు",
    sms_notifications_desc: "SMS ద్వారా నవీకరణలను స్వీకరించండి",
    save_preferences: "ప్రాధాన్యతలను సేవ్ చేయండి",
    security_privacy_header: "భద్రత & గోప్యత",
    security_privacy_header_desc: "సురక్షితమైన పాస్‌వర్డ్‌తో మీ ఖాతాను బలోపేతం చేయండి.",
    password_label: "పాస్‌వర్డ్",
    current_password: "ప్రస్తుత పాస్‌వర్డ్",
    new_password: "కొత్త పాస్‌వర్డ్",
    confirm_new_password: "కొత్త పాస్‌వర్డ్‌ను నిర్ధారించండి",
    update_password: "పాస్‌వర్డ్‌ను అప్‌డేట్ చేయండి",
    active_sessions_header: "యాక్టివ్ సెషన్‌లు",
    active_sessions_header_desc: "మీ ఖాతా ప్రస్తుతం లాగిన్ చేయబడిన పరికరాలను నిర్వహించండి.",
    this_device: "ఈ పరికరం",
    advanced_security: "అధునాతన భద్రత",
    advanced_security_desc: "ఈ ఖాతాకు అన్ని లాగిన్ ప్రయత్నాల కోసం బహుళ-కారకాల ప్రమాణీకరణ అవసరం.",
    enable_2fa: "2FA ప్రమాణీకరణను ప్రారంభించండి",
    customization_underway: "అనుకూలీకరణ జరుగుతోంది",
    customization_underway_desc: "మీ అనుభవంపై మీకు పూర్తి నియంత్రణను అందించడానికి మేము గ్రాన్యులర్ నోటిఫికేషన్ నియంత్రణలు మరియు పరికర నిర్వహణను నిర్మిస్తున్నాము."
  },
  security_page: {
    hero_badge: "భద్రత",
    hero_title: "బ్యాంక్-స్థాయి భద్రత",
    hero_subtitle: "మీ వ్యాపారం కోసం.",
    hero_desc: "మీ వ్యాపార డేటా ఎంటర్‌ప్రైజ్-స్థాయి భద్రతా చర్యలతో రక్షించబడుతుంది.",
    measures_title: "మా భద్రతా చర్యలు",
    measures_desc: "బహుళ అంచెల భద్రత మీ డేటాను ప్రతి స్థాయిలో రక్షిస్తుంది.",
    compliance_title: "వర్తింపు & ధృవీకరణలు",
    compliance_desc: "మేము అత్యున్నత స్థాయి వర్తింపు మరియు భద్రతా ధృవీకరణలను నిర్వహిస్తాము.",
    best_practices_title: "భద్రతా ఉత్తమ పద్ధతులు",
    best_practices_desc: "ఈ ఉత్తమ పద్ధతులను అనుసరించడం ద్వారా మీ ఖాతాను సురక్షితంగా ఉంచడంలో మాకు సహాయపడండి:",
    reporting_title: "భద్రతా సమస్యలను నివేదించడం",
    reporting_desc: "మీరు ఏదైనా భద్రతా దుర్బలత్వాన్ని కనుగొంటే, దయచేసి వెంటనే మాకు నివేదించండి.",
    responsible_disclosure: "బాధ్యతాయుతమైన బహిర్గతం",
    responsible_disclosure_desc: "భద్రతా వివరాలను ఇమెయిల్ చేయండి:",
    contact_team: "సెక్యూరిటీ టీమ్‌ని సంప్రదించండి",
    view_privacy: "గోప్యతా విధానాన్ని వీక్షించండి",
    priority_title: "మీ భద్రత మా ప్రాధాన్యత",
    priority_desc: "మీ వ్యాపార డేటాను రక్షించడానికి మేము నిరంతరం భద్రతా మౌలిక సదుపాయాలలో పెట్టుబడి పెడతాము.",
    feature_encryption: "End-to-End Encryption",
    feature_encryption_desc: "All data is encrypted using AES-256 encryption both in transit (TLS 1.3) and at rest. Your business data is protected with bank-grade security standards.",
    feature_audits: "Regular Security Audits",
    feature_audits_desc: "We conduct regular security audits, penetration testing, and vulnerability assessments to identify and address potential security issues proactively.",
    feature_access: "Access Controls",
    feature_access_desc: "Role-based access control (RBAC) ensures that users only have access to the data and features they need. Multi-factor authentication (MFA) is available for enhanced security.",
    feature_backups: "Data Backups",
    feature_backups_desc: "Automated daily backups ensure your data is safe. Backups are encrypted and stored in geographically distributed data centers for redundancy and disaster recovery.",
    feature_compliance: "Compliance & Certifications",
    feature_compliance_desc: "We comply with the Digital Personal Data Protection Act (DPDP Act) and maintain SOC 2 Type II compliance. Regular compliance audits ensure we meet the highest standards.",
    feature_incident: "Incident Response",
    feature_incident_desc: "Our security team monitors systems 24/7 and has a comprehensive incident response plan. We notify affected users promptly in the event of any security incident.",
    practice_passwords: "Use strong, unique passwords for your Soma account",
    practice_mfa: "Enable multi-factor authentication (MFA) for added security",
    practice_access: "Regularly review and update user access permissions",
    practice_contact: "Keep your contact information up to date for security notifications",
    practice_logout: "Log out from shared or public computers",
    practice_report: "Report any suspicious activity immediately to security@soma.com",
    comp_dpdp: "DPDP Act Compliance",
    comp_dpdp_desc: "Full compliance with India's Digital Personal Data Protection Act",
    comp_soc2: "SOC 2 Type II",
    comp_soc2_desc: "Certified for security, availability, and confidentiality",
    comp_iso: "ISO 27001",
    comp_iso_desc: "Information security management system certified",
    comp_gst: "GST Compliance",
    comp_gst_desc: "Secure handling of tax data per Indian regulations",
    compliance_disclaimer: "* Security standards and certifications are part of our development roadmap and compliance goals.",
    reporting_ack: "We will acknowledge receipt within 24 hours and work with you to address the issue promptly."
  },
  subscription_page: {
    subscription: "సబ్‌స్క్రిప్షన్",
    manage_subscription: "మీ సబ్‌స్క్రిప్షన్ ప్లాన్ మరియు బిల్లింగ్ వివరాలను నిర్వహించండి.",
    current_plan: "ప్రస్తుత ప్లాన్",
    gst_settings: "GST సెట్టింగ్‌లు",
    gst_settings_desc: "మీ GST సెట్టింగ్‌లను నిర్వహించండి మరియు మీ వ్యాపార అనుకూలత మరియు ఇన్‌వాయిసింగ్ కోసం GST ఫీచర్‌లను ప్రారంభించండి.",
    available_plans: "అందుబాటులో ఉన్న ప్లాన్‌లు",
    plan_name: "ప్లాన్ పేరు",
    free_tier: "ఉచిత శ్రేణి",
    included_features: "చేర్చబడిన ఫీచర్లు",
    no_active_subscription: "యాక్టివ్ సబ్‌స్క్రిప్షన్ ఏదీ కనుగొనబడలేదు.",
    loading: "లోడ్ అవుతోంది...",
    configure_gst: "GSTని కాన్ఫిగర్ చేయండి",
    processing: "ప్రాసెస్ చేస్తోంది...",
    upgrade_plan: "ప్లాన్‌ను అప్‌గ్రేడ్ చేయండి",
    error_fetch_subscription: "సబ్‌స్క్రిప్షన్ వివరాలను పొందడంలో విఫలమైంది.",
    error_generic_subscription: "సబ్‌స్క్రిప్షన్ వివరాలను పొందడంలో లోపం సంభవించింది.",
    error_select_plan: "దయచేసి అప్‌గ్రేడ్ చేయడానికి ప్లాన్‌ను ఎంచుకోండి.",
    success_upgrade: "సబ్‌స్క్రిప్షన్ విజయవంతంగా అప్‌గ్రేడ్ చేయబడింది!",
    error_upgrade: "సబ్‌స్క్రిప్షన్ అప్‌గ్రేడ్ చేయడం విఫలమైంది.",
    error_upgrade_generic: "సబ్‌స్క్రిప్షన్ అప్‌గ్రేడ్ చేస్తున్నప్పుడు లోపం సంభవించింది.",
    error_business_not_found: "వ్యాపార ప్రొఫైల్ కనుగొనబడలేదు. దయచేసి ముందుగా ఒకదాన్ని సృష్టించండి.",
    error_fetch_business: "వ్యాపార వివరాలను పొందడంలో విఫలమైంది."
  },

  placeholders: {
      select_language: "భాషను ఎంచుకోండి",
      select_timezone: "టైమ్‌జోన్‌ను ఎంచుకోండి",
      enter_business_name: "వ్యాపార పేరును నమోదు చేయండి",
      select_business_type: "వ్యాపార రకాన్ని ఎంచుకోండి",
      enter_email: "business@example.com",
      enter_phone: "+91 98765 43210",
      enter_address: "పూర్తి చిరునామాను నమోదు చేయండి",
      select_category: "వర్గాన్ని ఎంచుకోండి",
      select_turnover_range: "టర్నోవర్ పరిధిని ఎంచుకోండి",
      gstin_placeholder: "22AAAAA0000A1Z5"
    },
    suppliers_page: {
      suppliers: "సరఫరాదారులు",
      manage_suppliers: "మీ సరఫరాదారులు మరియు కొనుగోళ్లను నిర్వహించండి",
      add_new_supplier: "కొత్త సరఫరాదారుని జోడించండి",
      total_suppliers: "మొత్తం సరఫరాదారులు",
      total_purchases: "మొత్తం కొనుగోళ్లు",
      active_suppliers: "యాక్టివ్ సరఫరాదారులు",
      success_rate: "విజయ రేటు",
      search_suppliers: "పేరు లేదా సంప్రదింపు వ్యక్తి ద్వారా శోధించండి...",
      no_suppliers: "సరఫరాదారులు లేరు",
      edit_supplier: "సరఫరాదారుని సవరించండి",
      delete_supplier: "సరఫరాదారుని తొలగించండి",
      supplier_name: "సరఫరాదారు పేరు",
      contact_person: "సంప్రదింపు వ్యక్తి",
      phone: "ఫోన్",
      email: "ఇమెయిల్",
      gstin: "GSTIN",
      address: "చిరునామా",
      cancel: "రద్దు చేయండి",
      save: "సేవ్ చేయండి",
      delete_confirmation: "మీరు ఖచ్చితంగా ఈ సరఫరాదారుని తొలగించాలనుకుంటున్నారా?",
      actions: "చర్యలు",
      add_supplier: "సరఫరాదారుని జోడించండి",
      update_supplier: "సరఫరాదారుని అప్‌డేట్ చేయండి",
      supplier_details: "సరఫరాదారు వివరాలు",
      status: "స్థితి",
      general_liaison: "సాధారణ అనుసంధానకర్త",
      terms_net: "నిబంధనలు: నెట్",
      no_suppliers_desc: "సరఫరాదారులు కనుగొనబడలేదు"
    },
    orders_page: {
      title: "ఆర్డర్లు",
      description: "మీ అన్ని ఆర్డర్‌లను నిర్వహించండి",
      create_new_order: "కొత్త ఆర్డర్‌ని సృష్టించండి",
      total_orders: "మొత్తం ఆర్డర్లు",
      pending_orders: "పెండింగ్ ఆర్డర్లు",
      completed_orders: "పూర్తయిన ఆర్డర్లు",
      direct_sales: "ప్రత్యక్ష అమ్మకాలు",
      search_placeholder: "ఆర్డర్ ID లేదా కస్టమర్ పేరు ద్వారా శోధించండి...",
      filter_all: "అన్నీ",
      filter_pending: "పెండింగ్",
      filter_completed: "పూర్తయింది",
      no_orders: "ఆర్డర్లు లేవు",
      no_orders_desc: "ఆర్డర్లు కనుగొనబడలేదు",
      delete_confirmation: "ఈ ఆర్డర్‌ని తొలగించాలా?",
      col_order_id: "ఆర్డర్ ID",
      col_customer_name: "కస్టమర్ పేరు",
      guest: "అతిథి",
      col_order_status: "ఆర్డర్ స్థితి",
      standard: "ప్రామాణిక",
      col_amount: "మొత్తం",
      total: "మొత్తం",
      col_actions: "చర్యలు",
      wire: "వైర్",
      error_loading_sample: "లోడ్ అవుతోంది... నమూనా డేటాను చూపుతోంది"
    },
    gst_page: {
      tax_gst: "పన్ను & GST",
      manage_gst: "మీ GST రిటర్న్స్ మరియు పన్ను నిబంధనలను నిర్వహించండి",
      export_report: "పన్ను నివేదికను ఎగుమతి చేయండి",
      input_tax_credit: "ఇన్‌పుట్ టాక్స్ క్రెడిట్",
      tax_liability: "పన్ను బాధ్యత",
      pending_returns: "పెండింగ్ రిటర్న్స్",
      compliance_score: "కంప్లైయెన్స్ స్కోర్",
      gstin_check: "GSTIN చెక్",
      gst_returns: "GST రిటర్న్స్",
      auto_file_gst: "ఆటో ఫైల్ GST",
      past_returns: "గత రిటర్న్స్",
      gstin_verification: "GSTIN ధృవీకరణ",
      verify_gst_desc: "ప్రభుత్వ డేటాబేస్‌తో GST నంబర్‌ను ధృవీకరించండి.",
      verify_gst_subdesc: "ఏదైనా 15-అంకెల GST నంబర్‌ను తక్షణ ఫలితాలతో త్వరగా ధృవీకరించండి.",
      enter_gst_number: "15-అంకెల GST నంబర్‌ను నమోదు చేయండి...",
      check_gst_number: "GST నంబర్‌ను తనిఖీ చేయండి",
      checking: "తనిఖీ చేస్తోంది...",
      gst_verified: "GST నంబర్ ధృవీకరించబడింది",
      verified_successfully: "విజయవంతంగా ధృవీకరించబడింది",
      business_name: "వ్యాపార పేరు",
      state: "రాష్ట్రం",
      invalid_gst_number: "చెల్లని GST నంబర్",
      gst_not_valid: "GST నంబర్ చెల్లదు",
      all_returns_filed: "అన్ని రిటర్న్స్ దాఖలు చేయబడ్డాయి",
      returns_up_to_date: "మీ GST రిటర్న్స్ తాజాగా ఉన్నాయి",
      gstr1_sales: "GSTR-1 (అమ్మకాలు)",
      feature_auto_pop: "ఫీచర్: ఇన్‌వాయిస్‌ల నుండి ఆటో-పాపులేషన్",
      coming_soon: "త్వరలో వస్తుంది",
      gstr3b_summary: "GSTR-3B (సారాంశం)",
      feature_liability: "ఫీచర్: వన్-క్లిక్ లయబిలిటీ ఆఫ్‌సెట్",
      history_coming_soon: "చరిత్ర ఫీచర్ త్వరలో వస్తుంది.",
      return_type: "రిటర్న్ రకం",
      period: "కాలం",
      due_date: "గడువు తేదీ",
      status: "స్థితి",
      actions: "చర్యలు",
      submit_return: "రిటర్న్ సమర్పించండి",
      active: "సక్రియ",
      due: "బకాయి",
      maharashtra: "మహారాష్ట్ర"
    },
  customers_page: {
    customers: "కస్టమర్లు",
    manage_customers: "మీ కస్టమర్లు మరియు చెల్లింపులను నిర్వహించండి",
    add_new_customer: "కొత్త కస్టమర్‌ను జోడించండి",
    total_customers: "మొత్తం కస్టమర్లు",
    paid_customers: "చెల్లించిన కస్టమర్లు",
    pending_payments: "పెండింగ్ చెల్లింపులు",
    total_due: "మొత్తం బకాయి",
    search_placeholder: "పేరు, ఇమెయిల్ లేదా ఫోన్ ద్వారా శోధించండి...",
    all: "అన్నీ",
    paid: "చెల్లించినవి",
    due: "బకాయి",
    no_customers: "కస్టమర్లు లేరు",
    no_customers_desc: "ఏ కస్టమర్లు కనుగొనబడలేదు",
    customer_name: "కస్టమర్ పేరు",
    id: "ID",
    contact_details: "సంప్రదింపు వివరాలు",
    current_status: "ప్రస్తుత స్థితి",
    pending_payment: "పెండింగ్ చెల్లింపు",
    amount_due: "బకాయి మొత్తం",
    actions: "చర్యలు",
    delete_confirmation: "ఈ కస్టమర్‌ను తొలగించాలా?",
    status_pending: "పెండింగ్ చెల్లింపు",
    status_no_dues: "బకాయిలు లేవు",
    last_active: "చివరిగా సక్రియంగా"
  },
  purchases_page: {
    purchases: "కొనుగోళ్లు",
    manage_purchases: "మీ కొనుగోళ్లు మరియు చెల్లింపులను నిర్వహించండి",
    add_purchase: "కొనుగోలును జోడించండి",
    total_purchases: "మొత్తం కొనుగోళ్లు",
    total_spent: "మొత్తం ఖర్చు",
    pending_purchases: "పెండింగ్ కొనుగోళ్లు",
    pending_payment: "పెండింగ్ చెల్లింపు",
    search_placeholder: "సరఫరాదారు పేరు లేదా కొనుగోలు ID ద్వారా శోధించండి...",
    all: "అన్నీ",
    pending: "పెండింగ్",
    unpaid: "చెల్లించనివి",
    no_purchases: "కొనుగోళ్లు లేవు",
    no_purchases_desc: "ఏ కొనుగోళ్లు కనుగొనబడలేదు",
    id_date: "ID / తేదీ",
    supplier: "సరఫరాదారు",
    amount: "మొత్తం",
    before_tax: "పన్నుకు ముందు",
    status: "స్థితి",
    payment_status: "చెల్లింపు స్థితి",
    actions: "చర్యలు",
    delete_confirmation: "ఈ కొనుగోలును తొలగించాలా?",
    paid: "చెల్లించినవి",
    partial: "పాక్షికం"
  },
  inventory_page: {
    inventory: "ఇన్వెంటరీ",
    manage_inventory: "మీ ఉత్పత్తులు మరియు స్టాక్ స్థాయిలను నిర్వహించండి",
    add_product: "ఉత్పత్తిని జోడించండి",
    total_items: "మొత్తం అంశాలు",
    low_stock: "తక్కువ స్టాక్",
    out_of_stock: "స్టాక్ లేదు",
    stock_value: "స్టాక్ విలువ",
    search_placeholder: "కోడ్, పేరు లేదా రకం ద్వారా ఉత్పత్తులను శోధించండి...",
    all_items: "అన్ని అంశాలు",
    product_name: "ఉత్పత్తి పేరు",
    product_code: "ఉత్పత్తి కోడ్",
    stock_status: "స్టాక్ స్థితి",
    price: "ధర",
    before_tax: "పన్నుకు ముందు",
    actions: "చర్యలు",
    in_stock: "స్టాక్‌లో ఉంది",
    units: "యూనిట్లు",
    delete_confirmation: "ఈ ఉత్పత్తిని తొలగించాలా?",
    no_products: "ఉత్పత్తులు లేవు",
    no_products_desc: "ఏ ఉత్పత్తులు కనుగొనబడలేదు",
    edit_product: "ఉత్పత్తిని సవరించండి",
    delete_product: "ఉత్పత్తిని తొలగించండి",
    loading_sample_data: "లోడ్ అవుతోంది... నమూనా డేటాను చూపుతోంది"
  },
  billing_page: {
    title: "ఫైనాన్షియల్స్ & బిల్లింగ్",
    subtitle: "కార్పొరేట్ సబ్‌స్క్రిప్షన్‌లు మరియు వనరుల సెటిల్‌మెంట్ల కోసం నిర్మాణం",
    tabs: {
      subscription: "సబ్‌స్క్రిప్షన్",
      history: "చరిత్ర",
      settlements: "సెటిల్‌మెంట్లు",
      corporate_profile: "కార్పొరేట్ ప్రొఫైల్"
    },
    subscription: {
      tier_status: "టైర్ స్థితి",
      authenticated: "ధృవీకరించబడింది",
      renewal: "పునరుద్ధరణ: ",
      ascend_plan: "ప్లాన్‌ను పెంచండి",
      equilibrium_method: "ఈక్విలిబ్రియం పద్ధతి",
      recent_settlement: "ఇటీవలి సెటిల్‌మెంట్",
      verified: "ధృవీకరించబడింది"
    },
    history: {
      invoice_identifier: "ఇన్వాయిస్ గుర్తింపు",
      issuance_date: "జారీ తేదీ",
      settlement_amount: "సెటిల్‌మెంట్ మొత్తం",
      status: "స్థితి",
      actions: "చర్యలు",
      no_history_title: "సెటిల్‌మెంట్ చరిత్ర లేదు",
      no_history_desc: "మీ ధృవీకరించబడిన ఇన్వాయిస్‌లు ధృవీకరణ తర్వాత ఇక్కడ కనిపిస్తాయి."
    },
    settlements: {
      architecture_title: "సెటిల్‌మెంట్ ఆర్కిటెక్చర్",
      architecture_desc: "అధీకృత కార్పొరేట్ యాక్సెస్ పాయింట్లు",
      initialize_method: "పద్ధతిని ప్రారంభించండి",
      no_vectors: "ఎటువంటి సెటిల్‌మెంట్ వెక్టర్స్ గుర్తించబడలేదు"
    },
    profile: {
      corporate_identity: "కార్పొరేట్ గుర్తింపు",
      tax_protocol: "పన్ను ప్రోటోకాల్ / GSTIN",
      registered_address: "నమోదిత చిరునామా",
      metropolis: "నగరం",
      jurisdiction: "అధికార పరిధి",
      postal_code: "పిన్ కోడ్",
      sovereignty: "దేశం",
      synchronizing: "సింక్రనైజ్ అవుతోంది...",
      authorize_updates: "నవీకరణలను ఆమోదించండి",
      update_success: "బిల్లింగ్ సమాచారం విజయవంతంగా నవీకరించబడింది"
    }
  },
  locations_page: {
    title: "లొకేషన్లు",
    subtitle: "బహుళ లొకేషన్లు మరియు స్టాక్ బదిలీలను నిర్వహించండి",
    transfer_stock: "స్టాక్ బదిలీ",
    add_location: "లొకేషన్ జోడించండి",
    total_locations: "లొకేషన్లు",
    active_locations: "యాక్టివ్ లొకేషన్లు",
    total_stock: "మొత్తం స్టాక్",
    transfers_progress: "పురోగతిలో ఉన్న బదిలీలు",
    tabs: {
      locations: "లొకేషన్లు",
      all_stock: "అన్ని లొకేషన్ల స్టాక్",
      transfers: "స్టాక్ బదిలీలు",
      analytics: "విశ్లేషణలు"
    },
    table: {
      location_name: "లొకేషన్ పేరు",
      type: "రకం",
      address: "చిరునామా",
      contact: "సంప్రదించండి",
      status: "స్థితి",
      actions: "చర్యలు",
      active: "యాక్టివ్",
      inactive: "నిష్క్రియం",
      store: "స్టోర్",
      warehouse: "గిడ్డంగి",
      view_details: "వివరాలను చూడండి",
      edit: "సవరించండి",
      delete: "తొలగించండి"
    },
    transfer_table: {
      date: "బదిలీ తేదీ",
      date_label: "తేదీ",
      route: "నుండి → వరకు"
    },
    empty_state: {
      no_locations: "లొకేషన్లు కనుగొనబడలేదు",
      no_locations_desc: "మీరు ఇంకా ఏ లొకేషన్లను జోడించలేదు. ప్రారంభించడానికి స్టోర్ లేదా గిడ్డంగిని జోడించండి.",
      no_transfers: "బదిలీలు కనుగొనబడలేదు",
      no_transfers_desc: "మీరు ఇంకా ఎటువంటి స్టాక్ బదిలీలను ప్రారంభించలేదు.",
      no_stock: "స్టాక్ డేటా లేదు",
      no_stock_desc: "ఎంచుకున్న లొకేషన్ కోసం స్టాక్ డేటా అందుబాటులో లేదు."
    },
    analytics: {
      sales_analysis: "విక్రయ విశ్లేషణ",
      coming_soon: "అధునాతన విశ్లేషణలు త్వరలో రానున్నాయి."
    }
  },
  usage_page: {
    title: "వినియోగం & పరిమితులు",
    subtitle: "మీ వినియోగం మరియు పరిమితులను వీక్షించండి",
    export_report: "నివేదికను ఎగుమతి చేయండి",
    cards: {
      api_calls: "API కాల్‌లు",
      storage_used: "స్టోరేజ్ ఉపయోగించబడింది",
      data_transfer: "డేటా బదిలీ",
      processing_time: "ప్రాసెసింగ్ సమయం"
    },
    tabs: {
      system_status: "సిస్టమ్ స్థితి",
      usage_limits: "వినియోగ పరిమితులు",
      usage_history: "వినియోగ చరిత్ర",
      alerts: "హెచ్చరికలు"
    },
    monitor: {
      system_health: "సిస్టమ్ ఆరోగ్యం",
      current_system_status: "ప్రస్తుత సిస్టమ్ స్థితి",
      uptime: "అప్‌టైమ్",
      response_time: "ప్రతిస్పందన సమయం",
      errors: "లోపాలు",
      database_usage: "డేటాబేస్ వినియోగం",
      auto_scaling: "ఆటో స్కేలింగ్",
      system_running_smoothly: "సిస్టమ్ సజావుగా నడుస్తోంది.",
      system_running_desc: "వినియోగం ఆధారంగా సిస్టమ్ వనరులను స్వయంచాలకంగా నిర్వహిస్తోంది. వేగవంతమైన పనితీరు కోసం సిస్టమ్ బాగా నడుస్తోంది.",
      manage_auto_scaling: "ఆటో స్కేలింగ్‌ని నిర్వహించండి"
    },
    quotas: {
      usage_limit: "వినియోగ పరిమితి",
      used: "ఉపయోగించబడింది",
      total_limit: "మొత్తం పరిమితి"
    },
    history: {
      date: "తేదీ",
      api_calls: "API కాల్‌లు",
      storage: "స్టోరేజ్",
      data_transfer: "డేటా బదిలీ",
      reqs: "అభ్యర్థనలు",
      no_history: "చరిత్ర లేదు",
      no_history_desc: "వినియోగ చరిత్ర ఇక్కడ కనిపిస్తుంది"
    },
    alerts: {
      fix_issue: "సమస్యను పరిష్కరించండి",
      all_systems_good: "అన్ని సిస్టమ్‌లు బాగున్నాయి",
      no_issues_found: "ఎలాంటి సమస్యలు కనుగొనబడలేదు"
    }
  },
  sidebar: {
    menu: {
      overview: "అవలోకనం",
      business: "వ్యాపారం",
      finance: "ఆర్థికం",
      system: "సిస్టమ్"
    },
    items: {
      dashboard: "డ్యాష్‌బోర్డ్",
      analytics: "విశ్లేషణలు",
      business_profile: "వ్యాపార ప్రొఫైల్",
      inventory: "ఇన్వెంటరీ",
      orders: "ఆర్డర్లు",
      purchases: "కొనుగోళ్లు",
      customers: "కస్టమర్లు",
      suppliers: "సరఫరాదారులు",
      business_settings: "వ్యాపార సెట్టింగ్‌లు",
      tax_gst: "పన్ను & GST",
      billing: "బిల్లింగ్",
      subscription: "చందా",
      locations: "స్థానాలు",
      settings: "సెట్టింగ్‌లు",
      usage: "వినియోగం"
    },
    footer: {
      upgrade_pro: "Pro కి అప్‌గ్రేడ్ చేయండి",
      account: "ఖాతా",
      billing: "బిల్లింగ్",
      notifications: "నోటిఫికేషన్లు",
      logout: "లాగ్ అవుట్"
    }
  }
};